<template>
    <div>
        <breadcrumb :routerList="[{title:'特价列表(朗康)'},{title:'特价新增(朗康)'}]"/>
        <div class="bigDiv ahstyles">
            <div class="h-piece">
                <div>
                    <div class="h-pieceTitle2" style="margin-bottom: 0.4rem;">
                        <h1>特价立项信息</h1>
                    </div>
                    <div class="pieceCon n-bu">
                        <div class="h-pieceCon2">
                            <div class="h-formLine ">
                                <el-form
                                        label-position=right
                                        :model="offer"
                                        ref="formLabelAlign2"
                                        :inline="true"
										:rules="rule"
                                        class="demo-ruleForm h-formbLine">
                                    <el-form-item
                                            label="创建人"
                                            class="h-elformWrap-2 "
                                            prop="cuname"
                                            v-if="offer.cuname">
                                        <el-input
                                                v-model="offer.cuname"
                                                placeholder=""
                                                readonly
                                                disabled>
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item
                                            label="创建人编码"
                                            class="h-elformWrap-2 "
                                            prop="cucode"
                                            v-if="offer.cucode">
                                        <el-input
                                                v-model="offer.cucode"
                                                placeholder=""
                                                readonly
                                                disabled>
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item
                                            label="创建时间"
                                            class="h-elformWrap-2 "
                                            prop="cdate"
                                            v-if="offer.cdate">
                                        <el-input
                                                v-model="offer.cdate"
                                                placeholder=""
                                                readonly
                                                disabled>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item
                                            label="特价类型"
                                            class="h-elformWrap-2"
                                            v-if="isSh"
                                            :prop="!(shenpiyemian||chakanyemian||yitijiaoshenpi)?'category':''">
                                        <brselect
                                                clearable
                                                category="category_tejia_sh"
                                                :v="offer.category"
                                                v-model="offer.category"
                                                @change="tejialeixingxuanze"
                                                :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian">
                                        </brselect>
                                    </el-form-item>
                                    <el-form-item
                                            label="特价类型"
                                            class="h-elformWrap-2"
                                            v-else
                                            :prop="!(shenpiyemian||chakanyemian||yitijiaoshenpi)?'category':''">
                                        <brselect
                                                v-if="shenpiyemian||yitijiaoshenpi||chakanyemian"
                                                clearable
                                                category="category_tejia"
                                                :v="offer.category"
                                                v-model="offer.category"
                                                @change="tejialeixingxuanze"
                                                :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian">
                                        </brselect>

                                        <brselect
                                                v-else
                                                clearable
                                                category="category_tejia_xinzeng"
                                                :v="offer.category"
                                                v-model="offer.category"
                                                @change="tejialeixingxuanze"
                                                :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian">
                                        </brselect>
                                    </el-form-item>

                                    <el-form-item
											v-if="offer.category==4"
                                            label="选择使用人"
                                            class="h-elformWrap-2"
                                            style="position:relative"
                                            >
											<!-- :rules="[{ required: shenpiyemian==true?false:offer.category!=4 , message: '请选择使用人', trigger: 'blur'},]" -->
                                        <el-input
                                                v-model="offer.xuanzhongren"
                                                placeholder=""
                                                readonly
                                                :disabled='shenpiyemian||yitijiaoshenpi||chakanyemian'>
                                            <i
                                                    class="el-icon-search el-input__icon"
                                                    slot="suffix"
                                                    @click="tanchuxuanzeren"
                                                    v-if='!shenpiyemian&&!yitijiaoshenpi&&!chakanyemian'>
                                            </i>
                                        </el-input>
                                    </el-form-item>
									<el-form-item
											v-else
									        label="选择使用人"
									        class="h-elformWrap-2"
									        style="position:relative"
											prop="xuanzhongren"
									        >
											<!-- :rules="[{ required: shenpiyemian==true?false:offer.category!=4 , message: '请选择使用人', trigger: 'blur'},]" -->
									    <el-input
									            v-model="offer.xuanzhongren"
									            placeholder=""
									            readonly
									            :disabled='shenpiyemian||yitijiaoshenpi||chakanyemian'>
									        <i
									                class="el-icon-search el-input__icon"
									                slot="suffix"
									                @click="tanchuxuanzeren"
									                v-if='!shenpiyemian&&!yitijiaoshenpi&&!chakanyemian'>
									        </i>
									    </el-input>
									</el-form-item>

                                  <el-form-item prop="salesregion" label="销售区域" :rules="[
                                    { required: true, message: '请选择销售区域', trigger:['change', ' blur','input']},
                                  ]" class="h-elformWrap-2">
                                    <el-select v-model="offer.salesregion" placeholder="请选择" @change="changeSalesregion" style="width:100%">
                                      <el-option v-for="item in salesregionListFilter"
                                                 :key="item.code"
                                                 :label="item.name"
                                                 :value="item.code"
                                                 >
                                      </el-option>
                                    </el-select>

                                  </el-form-item>

                                  <el-form-item label="对阵代理商" class="h-elformWrap-2" prop="contactAgentName" :rules="[
                                    { required: true, message: '请选择对阵代理商', trigger:['change', ' blur','input']},
                                  ]"v-if="this.hhdls">
                                      <el-select v-model="offer.contactAgentName" :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian" :title="offer.contactAgentName" remote filterable  placeholder="请输入" @change="changeAgent($event)">
                                          <el-option v-for="(item) in contactAgentList" :key="item.usercode" :label="item.agentName +'-'+item.agentCode" :value="item">
                                          </el-option>
                                      </el-select>
                                  </el-form-item>

                                    <!-- wlx!='1,9'（非服务订单）offer.leltypecode==1 （国内经销商[新增页面参数]）offer.agentType=='1' （国内经销商[暂存页面参数]）
                                    offer.category==5（高价订单）-->
                                    <el-form-item v-if="fwlx!='1,9' && (offer.leltypecode==1||offer.agentType=='1')" class="h-elformWrap-2" prop="isReform" label="是否改制单" >
                                        <el-switch
                                                v-model="offer.isReform"
                                                style="margin-left: 0.4rem;"
                                                @change="changeReform"
                                                :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian">
                                        </el-switch>
                                    </el-form-item>


                                    <el-form-item
                                            v-if="xuanzequyu"
                                            label="区域"
                                            class="h-elformWrap-2"
											:prop="!(shenpiyemian||chakanyemian||yitijiaoshenpi)?'type':''"
                                            >
                                        <brselect
                                                clearable
                                                category="neibu_haiwai_area"
                                                :v="offer.type"
                                                v-model="offer.type"
                                                @change="xuanzequyufangfa"
                                                :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian">
                                        </brselect>

                                    </el-form-item>

                                    <el-form-item
                                            v-if="xiangmuxinxishow"
                                            label="项目名称"
                                            class="h-elformWrap-2 "
                                            prop="xiangmuname"
                                    >

                                        <el-input
                                                v-model="offer.xiangmuname"
                                                placeholder=""
                                                readonly
                                                disabled>
                                        </el-input>

                                    </el-form-item>
                                    <br>

                                    <el-form-item
                                            v-if="xiangmuxinxishow"
                                            label="项目id"
                                            class="h-elformWrap-2 "
                                            prop="xiangmucode"
                                    >

                                        <el-input
                                                v-model="offer.xiangmucode"
                                                placeholder=""
                                                readonly
                                                disabled>
                                        </el-input>

                                    </el-form-item>

                                    <el-form-item
                                            v-if="canShowYlcs && cesuanshow"
                                            label="测算版本查看"
                                            class="h-elformWrap-2 "
                                            prop="xiangmucode"
                                    >

                                        <el-button type="text" size="small" class="h-tableLink h-btn"
                                                   @click="cesuanbanbenchakan">测算版本查看
                                        </el-button>

                                    </el-form-item>


                                    <el-form-item
                                            v-if="xuanzedengji"
                                            label="等级"
                                            class="h-elformWrap-2"
											:prop="!(shenpiyemian||chakanyemian||yitijiaoshenpi)?'type':''">

                                        <el-select v-model="offer.type"
                                                   :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian"
												   :placeholder="shenpiyemian||yitijiaoshenpi||chakanyemian?'':'请选择'"
												   :class="{'ljjSelectdisabled':shenpiyemian||yitijiaoshenpi||chakanyemian}"
                                                   clearable>
                                            <el-option
                                                    v-for="item in dengjixuanzelist"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>

                                    </el-form-item>



                                    <showxuanzeren
                                            :visible.sync="xuanzeren"
                                            ddlx="9"
                                            :nxWx="nxWX"
                                            v-if="xuanzeren"
                                            @choseObj="shiyongrenxuanze"
                                            oneflag
                                            title="选择经销商" :disabled='shenpiyemian||yitijiaoshenpi||chakanyemian'/>
                                    <shoudf
                                            :visible.sync="showshdfdialog"
                                            v-if="showshdfdialog"
                                            @choseObj="shiyongrenxuanze"
                                            oneflag
                                            ddlx="3"
                                            title="选择经销商"
                                            :disabled='shenpiyemian||yitijiaoshenpi||chakanyemian'/>
                                    <shouwuliao
                                            :visible.sync="xuanwuliao"
                                            v-if="xuanwuliao"
                                            :type="offer.type"
                                            :ddlx="fwlx"
                                            :isReform="offer.isReform"
                                            @choseObj="chanpinxinghaochangetype"
                                            :usercode="offer.userCode"
                                            :areaCode="offer.salesregion"
                                            :category="offer.category"
                                            :contactAgent="offer.contactAgent"
                                            oneflag
                                            title="选择物料" :disabled='shenpiyemian||yitijiaoshenpi||chakanyemian'/>
                                    <el-form-item
                                            label="工程项目"
                                            class="h-elformWrap-2"
                                            v-if="offer.category!=null&&offer.category!=''&&offer.category==0"
											:prop="!(shenpiyemian||chakanyemian||yitijiaoshenpi)?'pid':''">
                                        <el-select v-model="offer.pid"
                                                   @change="xiangmumingchengchangetype"
                                                   :disabled='shenpiyemian||yitijiaoshenpi||chakanyemian'
												   :placeholder="shenpiyemian||yitijiaoshenpi||chakanyemian?'':'请选择'"
												   :class="{'ljjSelectdisabled':shenpiyemian||yitijiaoshenpi||chakanyemian}"
                                                   @focus="jiantingshiyongren">
                                            <el-option
                                                    v-for="item in xiangmumingchengOptions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <br>
                                    <el-form-item
                                            label="特价有效期"
                                            class="h-elformWrap-2"
											:prop="!(shenpiyemian||chakanyemian||yitijiaoshenpi)?'youxiaoqi':''">
                                        <template>
                                            <div class=" block">
                                                <el-date-picker
                                                        v-model="offer.youxiaoqi"
                                                        type="daterange"
                                                        range-separator=" 至 "
                                                        start-placeholder="开始日期"
                                                        end-placeholder="结束日期"
                                                        style="width: 6rem"
                                                        value-format="yyyy-MM-dd"
                                                        :disabled='shenpiyemian||yitijiaoshenpi||chakanyemian'>
                                                </el-date-picker>
                                            </div>
                                        </template>
                                    </el-form-item>

                                    <br>
                                    <el-form-item
											v-if="offer.category == 4 && !(shenpiyemian||yitijiaoshenpi||chakanyemian)"
                                            label="特价立项说明"
                                            class="h-elformWrap-2 "
											prop="tejiashuoming">
                                        <el-input type="text" v-model="offer.tejiashuoming" :v="offer.tejiashuoming"
										 :placeholder="shenpiyemian||yitijiaoshenpi||chakanyemian?'':'请输入说明'" style="width:7rem"
                                                  :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian"></el-input>
                                    </el-form-item>
									<el-form-item
											v-else
									        label="特价立项说明"
									        class="h-elformWrap-2 ">
									    <el-input type="text" v-model="offer.tejiashuoming" :v="offer.tejiashuoming"
										 :placeholder="shenpiyemian||yitijiaoshenpi||chakanyemian?'':'请输入说明'" style="width:7rem"
									              :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian"></el-input>
									</el-form-item>
                                    <br>
                                    <!-- 朗康 8 种文件上传（高价订单除外, 2026.07）start -->
                                    <template v-if="offer.category != 5">
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="项目特价申请单" style="width: 55%" prop="lk_sqdan" :rules="[{ required: true, message: '请上传项目特价申请单', trigger: 'change' }]">
                                                <brupload style="width: 5rem" :refid="fujianId" :reftype="lkRefTypes.lk_sqdan" :uploadflag="supplementMode || (!shenpiyemian&&!yitijiaoshenpi&&!chakanyemian)" delflag>
                                                </brupload>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="项目特价承诺书" style="width: 55%" prop="lk_chengno" :rules="[{ required: true, message: '请上传项目特价承诺书', trigger: 'change' }]">
                                                <brupload style="width: 5rem" :refid="fujianId" :reftype="lkRefTypes.lk_chengno" :uploadflag="supplementMode || (!shenpiyemian&&!yitijiaoshenpi&&!chakanyemian)" delflag>
                                                </brupload>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="中标合同" style="width: 55%" prop="lk_hetong" :rules="[{ required: true, message: '请上传中标合同', trigger: 'change' }]">
                                                <brupload style="width: 5rem" :refid="fujianId" :reftype="lkRefTypes.lk_hetong" :uploadflag="supplementMode || (!shenpiyemian&&!yitijiaoshenpi&&!chakanyemian)" delflag>
                                                </brupload>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="项目招投标文件" style="width: 55%">
                                                <brupload style="width: 5rem" :refid="fujianId" :reftype="lkRefTypes.lk_zbwj" :uploadflag="supplementMode || (!shenpiyemian&&!yitijiaoshenpi&&!chakanyemian)" delflag>
                                                </brupload>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="项目中标通知书（扫描件+盖章）" style="width: 55%">
                                                <brupload style="width: 5rem" :refid="fujianId" :reftype="lkRefTypes.lk_zhongbiao" :uploadflag="supplementMode || (!shenpiyemian&&!yitijiaoshenpi&&!chakanyemian)" delflag>
                                                </brupload>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="中间商合同" style="width: 55%">
                                                <brupload style="width: 5rem" :refid="fujianId" :reftype="lkRefTypes.lk_zhongjian" :uploadflag="supplementMode || (!shenpiyemian&&!yitijiaoshenpi&&!chakanyemian)" delflag>
                                                </brupload>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="供货发票" style="width: 55%">
                                                <brupload style="width: 5rem" :refid="fujianId" :reftype="lkRefTypes.lk_fapiao" :uploadflag="supplementMode || (!shenpiyemian&&!yitijiaoshenpi&&!chakanyemian)" delflag>
                                                </brupload>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="其他资料" style="width: 55%">
                                                <brupload style="width: 5rem" :refid="fujianId" :reftype="lkRefTypes.lk_other" :uploadflag="supplementMode || (!shenpiyemian&&!yitijiaoshenpi&&!chakanyemian)" delflag>
                                                </brupload>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    </template>
                                    <!-- 高价订单：单个改制申请单上传（非必填, 2026.07）start -->
                                    <template v-if="offer.category == 5">
                                        <el-row :gutter="20">
                                            <el-col :span="12">
                                                <el-form-item label="改制申请单" style="width: 55%">
                                                    <brupload style="width: 5rem" :refid="fujianId" reftype="lk_gaizhi" :uploadflag="supplementMode || (!shenpiyemian&&!yitijiaoshenpi&&!chakanyemian)" delflag>
                                                    </brupload>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </template>
                                    <!-- 高价订单：单个改制申请单上传 end -->
                                    <!-- 朗康 8 种文件上传 end -->
                                  <br>
                                  <el-form-item label="项目说明" prop="projectDescription" v-if="xiangmuxinxishow">
                                    <div style="width: 7rem;border-bottom: 1px solid #dedede;color: #868686;word-break:break-all;">{{formLabelAlign.projectDescription}}</div>
                                  </el-form-item>
                                  <br>
                                  <el-form-item v-if="xiangmuxinxishow" label="招标公告" class="h-elformWrap-2" >
                                    <brupload
                                        style="width: 7rem;"
                                        :refid= formLabelAlign.id
                                        reftype=zbwj
                                        :showtime="false"
                                    >
                                    </brupload>
                                  </el-form-item>
                                  <br>
                                  <el-form-item v-if="xiangmuxinxishow" label="项目价格承诺书" class="h-elformWrap-2" >
                                    <brupload
                                        style="width: 7rem;"
                                        :refid= formLabelAlign.id
                                        reftype=jgcns
                                        :showtime="false"
                                    >
                                    </brupload>
                                  </el-form-item>
                                    <br>
                                    <el-form-item v-if="xiangmuxinxishow" label="中标公告（带价格）" class="h-elformWrap-2" >
                                        <brupload
                                                style="width: 7rem;"
                                                :refid= formLabelAlign.id
                                                reftype=项目-中标公告
                                                :showtime="false"
                                        >
                                        </brupload>
                                    </el-form-item>
                                    <br>
                                    <el-form-item v-if="xiangmuxinxishow" label="发票" class="h-elformWrap-2" >
                                        <brupload
                                                style="width: 7rem;"
                                                :refid= formLabelAlign.id
                                                reftype=项目-发票
                                                :showtime="false"
                                        >
                                        </brupload>
                                    </el-form-item>
                                    <br>
                                    <el-form-item v-if="xiangmuxinxishow && offer.isFenxiao" label="分销合同" class="h-elformWrap-2" >
                                        <brupload
                                                style="width: 7rem;"
                                                :refid= formLabelAlign.id
                                                reftype=项目-分销合同
                                                :showtime="false"
                                        >
                                        </brupload>
                                    </el-form-item>
                                    <br>
                                  <el-form-item v-if="xiangmuxinxishow"  style="margin-bottom: 10px;" label="合同附件" class="h-elformWrap-2" prop="fujian">
                                    <brupload
                                        style="width: 7rem;"
                                        :refid=formLabelAlign.id
                                        reftype="htsc"
                                        :showtime="false"
                                    >
                                    </brupload>
                                  </el-form-item>
                                  <br>

                                    <el-form-item
                                            label="审批意见"
                                            class="h-elformWrap-2 "
											:prop="shenpiyemian?'shenheyijian':''"
                                            v-if="shenpiyemian||bohuiyemian">
                                        <el-input
                                                style="width: 10rem"
                                                v-model="offer.shenheyijian"
                                                placeholder="请输入"
                                                :disabled="bohuiyemian||yitijiaoshenpi">
                                        </el-input>
                                    </el-form-item>


                                </el-form>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  台阶政策    -->
                <div class="N-chan ljjtablepaddings1" v-if="offer.category==4">
                    <div class="h-pieceTitle2">
                        <h1>特价型号信息</h1>
                    </div>
                    <div class="yxtable ljjtable">
                        <el-table
                                ref="multipleTable"
                                :data="tableData3"
                                style="width: 100%"
                                border
                        >
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.isReform"
                                    prop="reformId"
                                    label="改制流水号"
                                    :show-overflow-tooltip="true"
                                    min-width="150">
                                <template slot-scope="scope">
                                    {{scope.row.reformId}}
                                </template>

                            </el-table-column>
                            <el-table-column
                                    prop="materialDescrition"
                                    label="产品型号"
                                    :show-overflow-tooltip="true"
                                    min-width="150"
                            >
                                <template slot-scope="scope">
                                    <div style="text-align: left;">{{scope.row.materialDescrition}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="proCode"
                                    label="产品编码"
                                    min-width="150"
                                    :show-overflow-tooltip="true"
                            >

                                <template slot-scope="scope">
                                    {{scope.row.proCode}}
                                </template>

                            </el-table-column>

                            <el-table-column
                                    prop="hid"
                                    label="产品大类"
                                    :show-overflow-tooltip="true"
                                    width="120"
                            >

                                <template slot-scope="scope">
                                    <dictname category="product_level" :v="scope.row.hid"/>
                                </template>

                            </el-table-column>
                            <el-table-column
                                    prop="tejiafangshi"
                                    label="特价方式"
                                    width="120">
                                <template slot-scope="scope">
                                    <dictname v-if="isSh" category="tejiafangshi_detail" v-model="scope.row.tejiafangshi" :v="scope.row.tejiafangshi"/>
                                    <brselect v-else class="h-tableInput" clearable category="tejiafangshi_detail" :v="scope.row.tejiafangshi"
                                              v-model="scope.row.tejiafangshi" @change="qiehuanjinezhekou(scope.row)"
                                              :disabled="offer.isReform != true"></brselect>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="dingjia"
                                    label="基准价"
                                    min-width="150">
                                <template slot-scope="scope">
                                    <el-select class="h-tableInput" v-model="scope.row.dingjia" placeholder="请选择"
                                               style="width: 100%;"
                                               :disabled="shenpiyemian||yitijiaoshenpi||scope.row.dingjiakexuan||chakanyemian">
                                        <el-option v-for="item in scope.row.dingjialist" :key="item.value"
                                                   :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="jineorzhekou"
                                    label="特价金额/折扣"
                                    width="130">

                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.jineorzhekou" placeholder="" type="number"
                                              :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian" @change="kaishishifu(scope.row)"
                                    ></el-input>
                                </template>

                            </el-table-column>
                            <el-table-column
                                    :show-overflow-tooltip="true"
                                    v-if="offer.isReform == true"
                                    prop="tejia"
                                    width="150"
                                    label="产品特价"
                            >
                                <template slot-scope="scope">
                                    <div v-if="scope.row.xianshizhehou">
                                        {{
                                        new
                                        big(scope.row.jineorzhekou).times(((/^\w*_\d*.*\d*$/.test(scope.row.dingjia)) ? scope.row.dingjia.split("_")[1] : scope.row.dingjia))
                                        }}
                                    </div>
                                    <div v-if="scope.row.xianshijine">
                                        {{
                                        new
                                        big(scope.row.jineorzhekou)
                                        }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.isReform == true"
                                    prop="reformPrice"
                                    label="单台加价"
                                    width="150">
                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.reformPrice" placeholder="" type="number"
                                              :disabled="true" ></el-input>

                                </template>
                            </el-table-column>
                            <el-table-column
                                    :show-overflow-tooltip="true"
                                    prop="tejia"
                                    width="150"
                                    label="特价"
                            >
                                <template slot-scope="scope">
                                    <div v-if="scope.row.xianshizhehou">
                                        {{
                                        new
                                        big(scope.row.jineorzhekou).times(((/^\w*_\d*.*\d*$/.test(scope.row.dingjia)) ? scope.row.dingjia.split("_")[1] : scope.row.dingjia))
                                        .plus(new big(scope.row.reformPrice || 0))
                                        }}
                                    </div>
                                    <div v-if="scope.row.xianshijine">
                                        {{
                                        new
                                        big(scope.row.jineorzhekou).plus(new big(scope.row.reformPrice || 0))
                                        }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="avaiNumber"
                                    label="数量"
                                    width="80">
                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.avaiNumber" placeholder="" type="number"
                                              :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian"
                                              @blur="kaishishifu(scope.row)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :show-overflow-tooltip="true"
                                    width="150"
                                    :prop="item.prop"
                                    :label="item.label" v-for="item in columndata" :key='item.label'
                            >
                                <template slot-scope="scope">

                                    <div v-if="scope.row.xianshizhehou">
                                        {{
                                        new big(scope.row.jineorzhekou || 0)
                                        .times((/^\w*_\d*.*\d*$/.test(scope.row.dingjia)) ? scope.row.dingjia.split("_")[1] : scope.row.dingjia)
                                        .plus(new big(scope.row.reformPrice || 0))
                                        .times(new big(scope.row.avaiNumber || 0))
                                        }}
                                    </div>
                                    <div v-if="scope.row.xianshijine">
                                        {{
                                        new big(scope.row.jineorzhekou || 0)
                                        .plus(new big(scope.row.reformPrice || 0))
                                        .times(new big(scope.row.avaiNumber || 0))
                                        }}
                                    </div>

                                </template>
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.agentType == 3"
                                    prop="baofei"
                                    label="保费"
                                    width="80"
                            >
                                <template slot-scope="scope">
                                    <!--                                    <div style="text-align: right;">
                                                                            {{scope.row.baofei?parseFloat(scope.row.baofei).toString():'0'}}
                                                                        </div>-->

                                    <el-input class="h-tableInput" v-model="scope.row.baofei" placeholder=""
                                              :disabled="shenpiyemian||yitijiaoshenpi"></el-input>

                                </template>
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.agentType == 3"
                                    prop="yongjin"
                                    label="佣金"
                                    width="80"
                            >
                                <template slot-scope="scope">
                                    <!--                                    <div style="text-align: right;">{{scope.row.yongjin?parseFloat(scope.row.yongjin).toString():'0'}}</div>-->
                                    <el-input class="h-tableInput" v-model="scope.row.yongjin" placeholder=""
                                              :disabled="shenpiyemian||yitijiaoshenpi"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.agentType == 3"
                                    prop="yunfei"
                                    label="运费"
                                    width="80"
                            >
                                <template slot-scope="scope">
                                    <!--                                    <div style="text-align: right;">{{scope.row.yunfei?parseFloat(scope.row.yunfei).toString():'0'}}</div>-->
                                    <el-input class="h-tableInput" v-model="scope.row.yunfei" placeholder=""
                                              :disabled="shenpiyemian||yitijiaoshenpi"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="操作"
                                    :width="shenpiyemian==false&&yitijiaoshenpi==false&&bohuiyemian==false?'220':'1'"
                                    fixed="right"
                                    v-if="shenpiyemian==false&&yitijiaoshenpi==false&&bohuiyemian==false"
                            >
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" class="h-tableLink h-btn"
                                               @click="delPlan(scope.$index,scope.row)"
                                               v-if="chakanyemian?false:(!shenpiyemian&&!yitijiaoshenpi&&!bohuiyemian)">删除
                                    </el-button>
                                    <el-button type="text" size="small" class="h-tableLink h-btn"
                                               @click="tejiachanpinshiyongqingkuang(scope.$index,scope.row)"
                                               v-if="chakanyemian==true">特价产品使用情况
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="h-tableAdd" @click="adds"
                             v-if="chakanyemian?false:(!shenpiyemian&&!yitijiaoshenpi&&!bohuiyemian)">
                            <a>新增一行</a>
                        </div>
                    </div>
                </div>

                <!--  特殊直扣  -->
                <div class="N-chan ljjtablepaddings1" v-if="offer.category==3">
                    <div class="h-pieceTitle2">
                        <h1>特价型号信息</h1>
                    </div>
                    <div class="yxtable">
                        <el-table
                                ref="multipleTable"
                                :data="tableData3"
                                style="width: 100%"
                                border
                        >
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.isReform"
                                    prop="reformId"
                                    label="改制流水号"
                                    :show-overflow-tooltip="true"
                                    min-width="150">
                                <template slot-scope="scope">
                                    {{scope.row.reformId}}
                                </template>

                            </el-table-column>
                            <el-table-column
                                    prop="materialDescrition"
                                    label="产品型号"
                                    :show-overflow-tooltip="true"
                                    min-width="150"
                            >
                                <template slot-scope="scope">
                                    <div style="text-align: left;">{{scope.row.materialDescrition}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="proCode"
                                    label="产品编码"
                                    min-width="150"
                                    :show-overflow-tooltip="true"
                            >

                                <template slot-scope="scope">
                                    {{scope.row.proCode}}
                                </template>

                            </el-table-column>

                            <el-table-column
                                    prop="hid"
                                    label="产品大类"
                                    :show-overflow-tooltip="true"
                                    width="120"
                            >

                                <template slot-scope="scope">
                                    <dictname category="product_level" :v="scope.row.hid"/>
                                </template>

                            </el-table-column>
                            <el-table-column
                                    prop="tejiafangshi"
                                    label="特价方式"
                                    width="120">
                                <template slot-scope="scope">
                                    <dictname v-if="isSh" category="tejiafangshi_detail" v-model="scope.row.tejiafangshi" :v="scope.row.tejiafangshi"/>
                                    <brselect v-else class="h-tableInput" clearable category="tejiafangshi_detail" :v="scope.row.tejiafangshi"
                                              v-model="scope.row.tejiafangshi" @change="qiehuanjinezhekou(scope.row)"
                                              :disabled="offer.isReform != true"></brselect>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="dingjia"
                                    label="基准价"
                                    min-width="150">
                                <template slot-scope="scope">
                                    <el-select class="h-tableInput" v-model="scope.row.dingjia" placeholder="请选择"
                                               style="width: 100%;"
                                               :disabled="shenpiyemian||yitijiaoshenpi||scope.row.dingjiakexuan||chakanyemian">
                                        <el-option v-for="item in scope.row.dingjialist" :key="item.value"
                                                   :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="jineorzhekou"
                                    label="特价金额/折扣"
                                    width="130">

                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.jineorzhekou" placeholder="" type="number"
                                              :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian" @change="kaishishifu(scope.row)"
                                    ></el-input>
                                </template>

                            </el-table-column>
                            <el-table-column
                                    :show-overflow-tooltip="true"
                                    v-if="offer.isReform == true"
                                    prop="tejia"
                                    width="150"
                                    label="产品特价"
                            >
                                <template slot-scope="scope">
                                    <div v-if="scope.row.xianshizhehou">
                                        {{
                                        new
                                        big(scope.row.jineorzhekou).times(((/^\w*_\d*.*\d*$/.test(scope.row.dingjia)) ? scope.row.dingjia.split("_")[1] : scope.row.dingjia))
                                        }}
                                    </div>
                                    <div v-if="scope.row.xianshijine">
                                        {{
                                        new
                                        big(scope.row.jineorzhekou)
                                        }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.isReform == true"
                                    prop="reformPrice"
                                    label="单台加价"
                                    width="150">
                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.reformPrice" placeholder="" type="number"
                                              :disabled="true" ></el-input>

                                </template>
                            </el-table-column>
                            <el-table-column
                                    :show-overflow-tooltip="true"
                                    prop="tejiareform"
                                    width="150"
                                    label="特价"
                            >
                                <template slot-scope="scope">
                                    <div v-if="scope.row.xianshizhehou">
                                        {{
                                        new
                                        big(scope.row.jineorzhekou).times(((/^\w*_\d*.*\d*$/.test(scope.row.dingjia)) ? scope.row.dingjia.split("_")[1] : scope.row.dingjia))
                                        .plus(new big(scope.row.reformPrice || 0))
                                        }}
                                    </div>
                                    <div v-if="scope.row.xianshijine">
                                        {{
                                        new
                                        big(scope.row.jineorzhekou).plus(new big(scope.row.reformPrice || 0))
                                        }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="avaiNumber"
                                    label="数量"
                                    width="80">
                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.avaiNumber" placeholder="" type="number"
                                              :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian"
                                              @blur="kaishishifu(scope.row)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :show-overflow-tooltip="true"
                                    width="150"
                                    :prop="item.prop"
                                    :label="item.label" v-for="item in columndata" :key='item.label'
                            >
                                <template slot-scope="scope">

                                    <div v-if="scope.row.xianshizhehou">
                                        {{
                                        new big(scope.row.jineorzhekou || 0)
                                        .times((/^\w*_\d*.*\d*$/.test(scope.row.dingjia)) ? scope.row.dingjia.split("_")[1] : scope.row.dingjia)
                                        .plus(new big(scope.row.reformPrice || 0))
                                        .times(new big(scope.row.avaiNumber || 0))
                                        }}
                                    </div>
                                    <div v-if="scope.row.xianshijine">
                                        {{
                                        new big(scope.row.jineorzhekou || 0)
                                        .plus(new big(scope.row.reformPrice || 0))
                                        .times(new big(scope.row.avaiNumber || 0))
                                        }}
                                    </div>

                                </template>
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.agentType == 3"
                                    prop="baofei"
                                    label="保费"
                                    width="80">
                                <template slot-scope="scope">
                                    <!--                                    <div style="text-align: right;">{{scope.row.baofei?parseFloat(scope.row.baofei).toString():'0'}}</div>-->
                                    <el-input class="h-tableInput" v-model="scope.row.baofei" placeholder=""
                                              :disabled="shenpiyemian||yitijiaoshenpi"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.agentType == 3"
                                    prop="yongjin"
                                    label="佣金"
                                    width="80"
                            >
                                <template slot-scope="scope">
                                    <!--                                    <div style="text-align: right;">{{scope.row.yongjin?parseFloat(scope.row.yongjin).toString():'0'}}</div>-->
                                    <el-input class="h-tableInput" v-model="scope.row.yongjin" placeholder=""
                                              :disabled="shenpiyemian||yitijiaoshenpi"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.agentType == 3"
                                    prop="yunfei"
                                    label="运费"
                                    width="80"
                            >
                                <template slot-scope="scope">
                                    <!--                                    <div style="text-align: right;">{{scope.row.yunfei?parseFloat(scope.row.yunfei).toString():'0'}}</div>-->
                                    <el-input class="h-tableInput" v-model="scope.row.yunfei" placeholder=""
                                              :disabled="shenpiyemian||yitijiaoshenpi"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="操作"
                                    :width="shenpiyemian==false&&yitijiaoshenpi==false&&bohuiyemian==false?'220':'1'"
                                    fixed="right"
                            >

                                <template slot-scope="scope">
                                    <el-button type="text" size="small" class="h-tableLink h-btn"
                                               @click="delPlan(scope.$index,scope.row)"
                                               v-if="chakanyemian?false:(!shenpiyemian&&!yitijiaoshenpi&&!bohuiyemian)">删除
                                    </el-button>
                                    <el-button type="text" size="small" class="h-tableLink h-btn"
                                               @click="tejiachanpinshiyongqingkuang(scope.$index,scope.row)"
                                               v-if="chakanyemian==true">特价产品使用情况
                                    </el-button>
                                </template>

                            </el-table-column>
                        </el-table>
                        <div class="h-tableAdd" @click="adds"
                             v-if="chakanyemian?false:(!shenpiyemian&&!yitijiaoshenpi&&!bohuiyemian)">
                            <a>新增一行</a>
                        </div>
                    </div>
                </div>

                <!--   高价订单  -->
                <div class="N-chan ljjtablepaddings1" v-if="offer.category==5">
                    <div class="h-pieceTitle2">
                        <h1>特价型号信息</h1>
                    </div>
                    <div class="yxtable">
                        <el-table
                                ref="multipleTable"
                                :data="tableData3"
                                style="width: 100%"
                                border
                        >
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.isReform"
                                    prop="reformId"
                                    label="改制流水号"
                                    :show-overflow-tooltip="true"
                                    min-width="150">
                                <template slot-scope="scope">
                                    {{scope.row.reformId}}
                                </template>

                            </el-table-column>
                            <el-table-column
                                    prop="materialDescrition"
                                    label="产品型号"
                                    :show-overflow-tooltip="true"
                                    min-width="150"
                            >
                                <template slot-scope="scope">
                                    <div style="text-align: left;">{{scope.row.materialDescrition}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="proCode"
                                    label="产品编码"
                                    min-width="150"
                                    :show-overflow-tooltip="true"
                            >

                                <template slot-scope="scope">
                                    {{scope.row.proCode}}
                                </template>

                            </el-table-column>

                            <el-table-column
                                    prop="hid"
                                    label="产品大类"
                                    :show-overflow-tooltip="true"
                                    width="120"
                            >

                                <template slot-scope="scope">
                                    <dictname category="product_level" :v="scope.row.hid"/>
                                </template>

                            </el-table-column>
                            <el-table-column
                                    prop="tejiafangshi"
                                    label="特价方式"
                                    width="120">
                                <template slot-scope="scope">
                                    <dictname v-if="isSh" category="tejiafangshi_detail" v-model="scope.row.tejiafangshi" :v="scope.row.tejiafangshi"/>
                                    <brselect v-else class="h-tableInput" clearable category="tejiafangshi_detail" :v="scope.row.tejiafangshi"
                                              v-model="scope.row.tejiafangshi" @change="qiehuanjinezhekou(scope.row)"
                                              :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian"></brselect>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="dingjia"
                                    label="基准价"
                                    min-width="150">
                                <template slot-scope="scope">
                                    <el-select class="h-tableInput" v-model="scope.row.dingjia" placeholder="请选择"
                                               style="width: 100%;"
                                               :disabled="shenpiyemian||yitijiaoshenpi||scope.row.dingjiakexuan||chakanyemian">
                                        <el-option v-for="item in scope.row.dingjialist" :key="item.value"
                                                   :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="jineorzhekou"
                                    label="特价金额/折扣"
                                    width="130">
                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.jineorzhekou" placeholder="" type="number"
                                              :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian" @change="kaishishifu(scope.row)"
                                    ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :show-overflow-tooltip="true"
                                    v-if="offer.isReform == true"
                                    prop="tejia"
                                    width="150"
                                    label="产品特价"
                            >
                                <template slot-scope="scope">
                                    <div v-if="scope.row.xianshizhehou">
                                        {{
                                        new
                                        big(scope.row.jineorzhekou).times(((/^\w*_\d*.*\d*$/.test(scope.row.dingjia)) ? scope.row.dingjia.split("_")[1] : scope.row.dingjia))
                                        }}
                                    </div>
                                    <div v-if="scope.row.xianshijine">
                                        {{
                                        new
                                        big(scope.row.jineorzhekou)
                                        }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.isReform == true"
                                    prop="reformPrice"
                                    label="单台加价"
                                    width="150">
                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.reformPrice" placeholder="" type="number"
                                              :disabled="true" ></el-input>

                                </template>
                            </el-table-column>
                            <el-table-column
                                    :show-overflow-tooltip="true"
                                    prop="tejiareform"
                                    width="150"
                                    label="特价"
                            >
                                <template slot-scope="scope">
                                    <div v-if="scope.row.xianshizhehou">
                                        {{
                                        new
                                        big(scope.row.jineorzhekou).times(((/^\w*_\d*.*\d*$/.test(scope.row.dingjia)) ? scope.row.dingjia.split("_")[1] : scope.row.dingjia))
                                        .plus(new big(scope.row.reformPrice || 0))
                                        }}
                                    </div>
                                    <div v-if="scope.row.xianshijine">
                                        {{
                                        new
                                        big(scope.row.jineorzhekou).plus(new big(scope.row.reformPrice || 0))
                                        }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="avaiNumber"
                                    label="数量"
                                    width="80">
                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.avaiNumber" placeholder="" type="number"
                                              :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian"
                                              @blur="kaishishifu(scope.row)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :show-overflow-tooltip="true"
                                    width="150"
                                    :prop="item.prop"
                                    :label="item.label" v-for="item in columndata" :key='item.label'
                            >
                                <template slot-scope="scope">

                                    <div v-if="scope.row.xianshizhehou">
                                        {{
                                        new big(scope.row.jineorzhekou || 0)
                                        .times((/^\w*_\d*.*\d*$/.test(scope.row.dingjia)) ? scope.row.dingjia.split("_")[1] : scope.row.dingjia)
                                        .plus(new big(scope.row.reformPrice || 0))
                                        .times(new big(scope.row.avaiNumber || 0))
                                        }}
                                    </div>
                                    <div v-if="scope.row.xianshijine">
                                        {{
                                        new big(scope.row.jineorzhekou || 0)
                                        .plus(new big(scope.row.reformPrice || 0))
                                        .times(new big(scope.row.avaiNumber || 0))
                                        }}
                                    </div>

                                </template>
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.agentType == 3"
                                    prop="yongjin"
                                    label="佣金"
                                    width="80">
                                <template slot-scope="scope">
                                    <!--                                    <div style="text-align: right;">{{scope.row.yongjin?parseFloat(scope.row.yongjin).toString():'0'}}</div>-->
                                    <el-input class="h-tableInput" v-model="scope.row.yongjin" placeholder=""
                                              :disabled="shenpiyemian||yitijiaoshenpi"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.agentType == 3"
                                    prop="yunfei"
                                    label="运费"
                                    width="80"
                            >
                                <template slot-scope="scope">
                                    <!--                                    <div style="text-align: right;">{{scope.row.yunfei?parseFloat(scope.row.yunfei).toString():'0'}}</div>-->
                                    <el-input class="h-tableInput" v-model="scope.row.yunfei" placeholder=""
                                              :disabled="shenpiyemian||yitijiaoshenpi"></el-input>
                                </template>
                            </el-table-column>

                            <el-table-column
                                    label="操作"
                                    :width="shenpiyemian==false&&yitijiaoshenpi==false&&bohuiyemian==false?'220':'1'"
                                    fixed="right"
                                    v-if="shenpiyemian==false&&yitijiaoshenpi==false&&bohuiyemian==false"
                            >

                                <template slot-scope="scope">
                                    <el-button type="text" size="small" class="h-tableLink h-btn"
                                               @click="delPlan(scope.$index,scope.row)"
                                               v-if="chakanyemian?false:(!shenpiyemian&&!yitijiaoshenpi&&!bohuiyemian)">删除
                                    </el-button>
                                    <el-button type="text" size="small" class="h-tableLink h-btn"
                                               @click="tejiachanpinshiyongqingkuang(scope.$index,scope.row)"
                                               v-if="chakanyemian==true">特价产品使用情况
                                    </el-button>
                                </template>

                            </el-table-column>
                        </el-table>
                        <div class="h-tableAdd" @click="adds"
                             v-if="chakanyemian?false:(!shenpiyemian&&!yitijiaoshenpi&&!bohuiyemian)">
                            <a>新增一行</a>
                        </div>
                    </div>
                </div>


                <!--   项目特价  -->
                <div class="N-chan ljjtablepaddings1" v-if="offer.category==0">
                    <div class="h-pieceTitle2">
                        <h1>特价型号信息</h1>
                    </div>
                    <div class="yxtable">
                        <el-table
                                ref="multipleTable"
                                :data="tableData3"
                                style="width: 100%"
                                border
                                @cell-dblclick="dblclick"
                        >
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                            </el-table-column>

                            <el-table-column
                                    prop="proProductInfoid"
                                    label="产品型号"
                                    min-width="200">
                                <template slot-scope="scope">
                                    <el-select class="h-tableInput" v-model="scope.row.proProductInfoid" filterable placeholder="请选择"
                                               @change="chanpincodechange(scope.row)"
                                               v-if="!(shenpiyemian||yitijiaoshenpi||chakanyemian)">
                                        <el-option v-for="item in chanpincode" :key="item.value"
                                                   :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <div style="text-align: left;" v-if="shenpiyemian||yitijiaoshenpi||chakanyemian">{{scope.row.materialDescrition}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="proCode"
                                    label="产品编码"
                                    :show-overflow-tooltip="true"
                                    min-width="150">

                                <template slot-scope="scope">
                                    {{scope.row.proCode}}
                                </template>

                            </el-table-column>

                            <el-table-column
                                    prop="hid"
                                    label="产品大类"
                                    :show-overflow-tooltip="true"
                                    width="120"
                            >
                                <template slot-scope="scope">
                                    <dictname category="product_level" :v="scope.row.hid"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="tejiafangshi"
                                    label="特价方式"
                                    width="120">
                                <template slot-scope="scope">
                                    <dictname v-if="isSh" category="tejiafangshi_detail" v-model="scope.row.tejiafangshi" :v="scope.row.tejiafangshi"/>
                                    <brselect v-else class="h-tableInput" clearable category="tejiafangshi_detail" :v="scope.row.tejiafangshi"
                                              v-model="scope.row.tejiafangshi" @change="qiehuanjinezhekou(scope.row)"
                                              :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian"></brselect>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="jineorzhekou"
                                    label="特价金额/折扣"
                                    width="130">
                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.jineorzhekou" placeholder="" type="number"
                                              :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian"
                                    ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :show-overflow-tooltip="true"
                                    width="150"
                                    :prop="item.prop"
                                    :label="item.label" v-for="item in columndata" :key='item.label'
                            >
                                <template slot-scope="scope">
                                    <div v-if="scope.row.xianshizhehou">
                                        {{new
                                        big(scope.row.jineorzhekou?scope.row.jineorzhekou:0).times(scope.row.avaiNumber).times(((/^\w*_\d*.*\d*$/.test(scope.row.dingjia))?scope.row.dingjia.split("_")[1]:scope.row.dingjia))}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="bizhong"
                                    label="币种"
                                    width="200"
                            >
                                <template slot-scope="scope">
                                    <el-select class="h-tableInput" v-model="scope.row.bizhong" placeholder="请选择" disabled="disabled"
                                               @change="kaishishifu(scope.row)">
                                        <el-option v-for="item in scope.row.bizhongjihe" :key="item.value"
                                                   :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="dingjia"
                                    label="定价金额"
                                    :show-overflow-tooltip="true"
                                    min-width="150">

                                <template slot-scope="scope">
                                    {{ (/^\w*_\d*.\d*$/.test(scope.row.dingjia))?
                                    (scope.row.dingjia.split("_").length>1?scope.row.dingjia.split("_")[1]:scope.row.dingjia):scope.row.dingjia}}
                                </template>

                            </el-table-column>

                            <el-table-column
                                    prop="avaiNumber"
                                    label="数量"
                                    width="80">
                                <template slot-scope="scope">
                                    <div style="text-align: right;">{{scope.row.avaiNumber}}</div>
                                </template>
                            </el-table-column>

                            <el-table-column
                                    prop="applyPrice"
                                    label="项目申请价"
                                    :show-overflow-tooltip="true"
                                    min-width="100">

                                <template slot-scope="scope">
                                    {{scope.row.applyPrice}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="agentMaori"
                                    label="代理商毛利"
                                    :show-overflow-tooltip="true"
                                    min-width="100">

                                <template slot-scope="scope">
                                    {{scope.row.agentMaori}}
                                </template>
                            </el-table-column>

                            <el-table-column
                                    prop="fenxiaoPrice"
                                    label="分销价格"
                                    :show-overflow-tooltip="true"
                                    :v-if="offer.isFenxiao"
                                    min-width="100">

                                <template slot-scope="scope">
                                    {{ scope.row.fenxiaoPrice}}
                                </template>
                            </el-table-column>

                            <el-table-column
                                    prop="fenxiaoMaori"
                                    label="分销毛利"
                                    :v-if="offer.isFenxiao"
                                    :show-overflow-tooltip="true"
                                    v-if=""
                                    min-width="100">

                                <template slot-scope="scope">
                                    {{ scope.row.fenxiaoMaori}}
                                </template>
                            </el-table-column>

                            <el-table-column
                                    prop="biddenPrice"
                                    label="项目终端价格"
                                    :show-overflow-tooltip="true"
                                    min-width="100">

                                <template slot-scope="scope">
                                    {{ scope.row.biddenPrice}}
                                </template>
                            </el-table-column>

                            <el-table-column
                                    v-if="offer.agentType == 3"
                                    prop="baofei"
                                    label="保费"
                                    width="80"
                            >
                                <template slot-scope="scope">
<!--                                    <div style="text-align: right;">{{scope.row.baofei?parseFloat(scope.row.baofei).toString():'0'}}</div>-->
                                    <el-input class="h-tableInput" v-model="scope.row.baofei" placeholder=""
                                              :disabled="shenpiyemian||yitijiaoshenpi"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.agentType == 3"
                                    prop="yongjin"
                                    label="佣金"
                                    width="80"
                            >
                                <template slot-scope="scope">
<!--                                    <div style="text-align: right;">{{scope.row.yongjin?parseFloat(scope.row.yongjin).toString():'0'}}</div>-->
                                    <el-input class="h-tableInput" v-model="scope.row.yongjin" placeholder=""
                                              :disabled="shenpiyemian||yitijiaoshenpi"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    v-if="offer.agentType == 3"
                                    prop="yunfei"
                                    label="运费"
                                    width="80"
                            >
                                <template slot-scope="scope">
<!--                                    <div style="text-align: right;">{{scope.row.yunfei?parseFloat(scope.row.yunfei).toString():'0'}}</div>-->
                                    <el-input class="h-tableInput" v-model="scope.row.yunfei" placeholder=""
                                              :disabled="shenpiyemian||yitijiaoshenpi"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="操作"
                                    :width="shenpiyemian==false&&yitijiaoshenpi==false&&bohuiyemian==false?'220':'1'"
                                    fixed="right"
                                    v-if="shenpiyemian==false&&yitijiaoshenpi==false&&bohuiyemian==false"
                            >
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" class="h-tableLink h-btn"
                                               @click="delPlan(scope.$index,scope.row)"
                                               v-if="chakanyemian?false:(!shenpiyemian&&!yitijiaoshenpi&&!bohuiyemian)">删除
                                    </el-button>
                                    <el-button type="text" size="small" class="h-tableLink h-btn"
                                               @click="tejiachanpinshiyongqingkuang(scope.$index,scope.row)"
                                               v-if="chakanyemian==true">特价产品使用情况
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="h-tableAdd" @click="adds"
                             v-if="chakanyemian?false:(!shenpiyemian&&!yitijiaoshenpi&&!bohuiyemian)">
                            <a>新增一行</a>
                        </div>
                    </div>
                </div>
                <br>
                <div style="margin:0 20px " v-if="canShowYlcs && cesuanshow">
                    <div class="yx_progressBar">
                        <div class="yxExtra" style="right: 2.5rem;top:0.4rem">
                            <div style="margin-bottom: 0.2rem;" ></div>
                        </div>
                        <div class="yx_topTip">
                            <div class="leftdes">
                                <span>材料毛利：</span><span class="percent">{{cailiaomaoli}}</span>
                            </div>
                            <div class="leftdes">
                                <span>经营贡献：</span><span class="percent">{{jingyinggongxian}}</span>
                            </div>
                            <div class="leftdes">
                                <span>经营贡献率：</span><span class="percent">{{jingyinggongxianlv}}</span>
                            </div>
                            <div class="leftdes">
                                <span>利润：</span><span class="percent">{{lirun}}</span>
                            </div>
                            <div class="leftdes">
                                <span>利润率：</span><span class="percent">{{lirunlv}}</span>
                            </div>
                        </div>

                    </div>
                </div>


                <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="showhistoryid"/>


            </div>
            <!--				<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="margin-top:20px;">批量导出</el-button>-->
            <el-row style="display: flex;justify-content: center;margin: 30px 0;">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="fanhuishangye">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="confirmSupplement" v-if="supplementMode">
                    确认补传
                </el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="zancuntijiao(0)"
                           v-if="chakanyemian?false:((!shenpiyemian?bohuiyemian?false:(offer.category!=null):false)&&!yitijiaoshenpi)">
                    暂存
                </el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="zancuntijiao(1)"
                           v-if="chakanyemian?false:((!shenpiyemian?bohuiyemian?false:(offer.category!=null):false)&&!yitijiaoshenpi)">
                    确认提交
                </el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="chongxintijiao" v-if="bohuiyemian&&!yitijiaoshenpi">
                    重新提交
                </el-button>
                <el-button class="el-button h-btn h-bBtn h-bgred el-button--default" @click="tongguobohui(1)"
                           v-if="shenpiyemian && _user.usercode!=offer.cucode || shenpiyemian && isHsj">驳回
                </el-button>
                <el-button class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="tongguobohui(2)"
                           v-if="shenpiyemian || shenpiyemian && isHsj">通过
                </el-button>
                <el-button
                        class="h-btn  h-bgblueQ2"
                        @click="genzongLiuch"
                        v-if="showhistoryid!=null">
                    跟踪审批
                </el-button>

            </el-row>
        </div>
    </div>
</template>


<script>
    import shouwuliao from '../../../components/dialog/wxwl-tejia'
    import showxuanzeren from '../../../components/dialog/selectshdfcesuan'
    import shoudf from '../../../components/dialog/selectshdf'
    import big from 'big.js'
    import ss from '../../../api/SystemService';
    import lkService from '../../../api/loud/tejia/lkService'
    import reformService from "@/api/reform/reformService";

    export default {

        components: {
            showxuanzeren,
            shouwuliao,
            shoudf
        },

        data() {
            return {
                canShowYlcs:true,
                fujianId: null,
                isSh: false,
                isFw: false,

                showshdfdialog: false,
              //是否是海盛杰用户
                isHsj: false,
                cailiaomaoli: '%',

                jingyinggongxian: '',

                jingyinggongxianlv: '%',

                lirun: '',

                lirunlv: '%',

                cesuanshow: false,

                cesuanid: '',

                xiangmuxinxishow: false,

                columndata: [],

                nidmap: {},

                dengjixuanzelist: [],

                xuanzedengji: false,

                xuanzequyu: false,

                shiyongrenbizhong: '',

                chakanyemian: false,

                showhistoryid: null,

                showhistory: false,

                //已提交审批
                yitijiaoshenpi: false,

                //驳回页面
                bohuiyemian: false,

                // 补传模式
                supplementMode: false,

                // 追踪 8 种文件上传状态
                lkFileUploaded: {
                    lk_sqdan: false,
                    lk_chengno: false,
                    lk_hetong: false,
                    lk_zbwj: false,
                    lk_zhongbiao: false,
                    lk_zhongjian: false,
                    lk_fapiao: false,
                    lk_other: false,
                },

                //ywid
                ywid: null,

                //instid
                instid: null,

                //taskid
                taskid: null,

                //特价版本id
                rversion: null,

                //是否审批页面
                shenpiyemian: false,

                //要删除的特价产品id
                yaoshanchude: [],

                zhekoupanduan: false,

                shifoutaijie: false,

                //是不是厚宏的代理商或平台商
                hhdls: false,

                // 朗康 8 种文件 reftype
                lkRefTypes: {
                    lk_zbwj:       'lk_zbwj',       // 项目招投标文件
                    lk_sqdan:      'lk_sqdan',      // 项目特价申请单（必传）
                    lk_chengno:    'lk_chengno',    // 项目特价承诺书（必传）
                    lk_zhongbiao:  'lk_zhongbiao',  // 项目中标通知书
                    lk_hetong:     'lk_hetong',     // 中标合同（必传）
                    lk_zhongjian:  'lk_zhongjian',  // 中间商合同
                    lk_fapiao:     'lk_fapiao',     // 供货发票
                    lk_other:      'lk_other',      // 其他资料
                },
                zhengmingziliao: '',

                //暂存提交特价版本id
                zancuntijiaobanben: '',
                supplementDeadline: '',
                supplementStatus: '',

                xuanwuliao: false,

                xiangmuchanpinmap: {},

                wuliaocode: [],

                xiangmumingchengOptions: [],

                salesregionList: [],
              //销售区域
                salesregionListFilter: [],

                fwlx:'',


                offer: {

                    gaojiadijia: '',

                    cuname: '',

                    cucode: '',

                    type: '',

                    pid: '',

                    youxiaoqi: ['', ''],

                    category: '',

                    //产品型号选中值
                    chanpinxinghao: '',

                    //选中物料
                    xuanzhongwuliao: '',

                    //审批意见
                    shenheyijian: '',

                    //项目名称
                    xiangmuname: null,

                    //项目id
                    xiangmucode: null,
                    tejiashuoming: null,
                    //是否改制单
                    isReform: false,

                    //是否分销
                    isFenxiao: false,

                    agentType:null,

                    contactAgent:null,

                    contactAgentName:null,

                    salesregion:null,
                },


                xuanzeren: false,
                nxWX: '',//1内销 2外销
                tableData3: [],


                bizhongListops: [],


                //特价可选物料
                kexuanwuliao: {},

                //项目产品集
                chanpincode: [],

                contactAgentList:[],

                formLabelAlign: {type:3,isSuccess:"2",proBidInfoList:[]},

                sizeForm: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                },

				rule:{
					category: [{ required: true, message: '请选择特价类型', trigger: 'change'}],
					xuanzhongren: [{ required: true, message: '请选择使用人', trigger: 'blur'}],
					type: [{ required: true, message: '请选择区域', trigger: 'change'}],
					type: [{ required: true, message: '请选择等级', trigger: 'change'}],
					pid: [{ required: true, message: '请选择项目', trigger: 'change'}],
					youxiaoqi: [{ required: true, message: '请选择有效期', trigger: 'change'}],
					tejiashuoming: [{ required: true, message: '请输入特价说明', trigger: 'blur'}],
					shenheyijian: [{ required: true, message: '请填写审批意见', trigger: 'blur'}]
				}

            }
        },
        mounted() {

        },


        created() {

            console.log(this.$route.query, 'this.$route.query')

            // 补传模式：加载特价数据 + 表单只读 + 文件可上传
            if (this.$route.query.supplement) {
                this.supplementMode = true;
                this.chakanyemian = true;
                this.rversion = this.$route.query.supplement;
                this.shenpijiazai();
            }

            this.nxWX = this.$route.query.nxWX;
            //从漏斗跳过来带类型
            if(this.$route.query.category){
              this.offer.category = this.$route.query.category
            }
            let funnelId = this.$route.query.funnelId
            if(funnelId){
              this.getDetailById(funnelId)
            }

//销售经理,经销商，都不能看
            if(this.$store.getters.hasRole("swyl_xiaoshoujl") || !this.$store.getters.isnbyh){
                this.canShowYlcs = false;
            }
            this.salesregionList = this.$store.getters.dictlist("YlSalesArea_chanpin");
            this.isHsj = this.$store.getters.hasRole("swyl_xiaoshoujl_hsj");
            //币种加载
            this.bizhongjiazai();

            if (this.$route.query.shtj) {
                this.isSh = true;
            }

            if (this.$route.query.fwtj) {
                this.isFw = true;
                this.fwlx = '1,9';
            }

            //若有审批
            if (this.$route.query.ywid) {

                //ywid
                this.ywid = this.$route.query.ywid;

                //instid
                this.instid = this.$route.query.instid;

                //taskid
                this.taskid = this.$route.query.taskid;

                //特价版本id
                this.rversion = this.$route.query.ywid;

                //审批信息加载
                this.shenpijiazai();


            } else if (this.$route.query.chakan) {

                //特价版本id
                this.rversion = this.$route.query.chakan;


                //信息加载
                this.shenpijiazai();


            } else {
                //普通页面加载
                this.putongjiazai();
            }


        },


        methods: {

            getLoudDetail(val, flag) {
              // 处理flag参数，默认设为true避免误判
              if (flag === false) {
                this.loud = false;
                return;
              }

              // 用let声明循环变量，确保异步回调能正确获取当前索引
              for (let i = 0; i < val.length; i++) {
                // 保存当前索引的副本，避免异步回调中i值错乱
                const currentIndex = i;
                const currentRow = val[currentIndex]; // 缓存当前行数据

                const q = {
                  usercode: this.offer.userCode,
                  ddlx: this.fwlx,
                  xmcode: this.XmCode,
                  type: this.offer.type,
                  matecode: currentRow.proCode, // 使用缓存的当前行编码
                  isReform: this.offer.isReform
                };

                // 处理改制订单号（改用async/await确保数据获取后再执行后续逻辑）
                const getReformIdLists = async () => {
                  if (this.offer.isReform) {
                    const q1 = {
                      agentCode: this.offer.userCode,
                      materialCode: currentRow.proCode
                    };
                    try {
                      const res = await reformService.getListByCode(q1);
                      return res.msg || []; // 确保返回数组，避免undefined
                    } catch (err) {
                      console.error("获取改制订单号失败：", err);
                      return [];
                    }
                  }
                  return [];
                };

                // 执行主逻辑
                (async () => {
                  const reformIdLists = await getReformIdLists(); // 等待改制订单号获取完成

                  try {
                    const rds = await ss.wuliaoselect.selecttejianewPage(q);
                    const valDetail = rds.records[0] || {}; // 避免无数据时报错

                    // 条件判断保留，但优化逻辑避免嵌套过深
                    const shouldProceed = this.offer.category !== 3
                        ? true
                        : (this.xuanzedengji ? this.shifouxuanzhong(valDetail) : true);

                    if (shouldProceed) {
                      const ind = [valDetail.matecode || currentRow.proCode]; // 降级处理，避免空值
                      const rd = await ss.xinzengtejianew.findkexuanwuliao(ind);
                      // 构建币种数据源
                      const bizhongjihe = [];
                      // 遍历rd.obj时增加空值判断，避免报错
                      let rdObjCData = null;
                      if (rd.obj && typeof rd.obj === 'object') {
                        // 先获取rd.obj的第一个键对应的数组（原逻辑中c为rd.obj的键）
                        const cKeys = Object.keys(rd.obj);
                        if (cKeys.length > 0) {
                          const firstCKey = cKeys[0];
                          rdObjCData = rd.obj[firstCKey];
                          // 确认rdObjCData是数组且有数据
                          if (Array.isArray(rdObjCData) && rdObjCData.length > 0) {
                            for (const cc of rdObjCData) { // 改用for...of更安全
                              for (const d of this.bizhongListops) { // 遍历币种列表
                                if (cc.currency === d.code) {
                                  // 币种匹配逻辑
                                  if (!this.shiyongrenbizhong || this.shiyongrenbizhong === cc.currency) {
                                    bizhongjihe.push({
                                      label: d.name,
                                      value: cc.currency
                                    });
                                  }
                                }
                              }
                            }
                          }
                        }
                      }

                      // 处理proCode的取值：先判断rd.obj是否有有效数据，无则用currentRow.proCode
                      let materialId = currentRow.proCode;
                      if (rdObjCData && Array.isArray(rdObjCData) && rdObjCData.length > 0) {
                        materialId = rdObjCData[0].materialid || currentRow.proCode;
                      }

                      // 处理hid的取值：先判断rd.obj是否有有效数据，无则用currentRow.hid
                      let hidValue = currentRow.hid || '';
                      if (rdObjCData && Array.isArray(rdObjCData) && rdObjCData.length > 0) {
                        const hidSystem = rdObjCData[0].hidSystem;
                        const hidMdm = rdObjCData[0].hidMdm;
                        hidValue = hidSystem ? hidSystem : (hidMdm ? hidMdm : currentRow.hid || '');
                      }

                      // 处理materialDescrition的取值：先判断rd.obj是否有有效数据，无则用currentRow的描述
                      let materialDesc = currentRow.materialDescrition || '';
                      if (rdObjCData && Array.isArray(rdObjCData) && rdObjCData.length > 0) {
                        const descSystem = rdObjCData[0].materialdescritionSystem;
                        const descMdm = rdObjCData[0].materialdescritionMdm;
                        materialDesc = descSystem ? descSystem : (descMdm ? descMdm : currentRow.materialDescrition || '');
                      }

                      // 更新表格数据（使用currentIndex确保索引正确）
                      if (this.tableData3[currentIndex]) {
                        // 使用this.$set确保Vue响应式更新
                        this.$set(this.tableData3, currentIndex, {
                          ...this.tableData3[currentIndex], // 保留原有字段
                          proCode: materialId,
                          hid: hidValue,
                          materialDescrition: materialDesc,
                          tejiafangshi: this.isSh ? '1' : '2',
                          jineorzhekou: '',
                          bizhong: '',
                          bizhongjihe: bizhongjihe,
                          dingjialist: [],
                          reformIdList: reformIdLists, // 已确保获取到的改制订单号
                          xianshizhehou: false,
                          zhehoujine: '',
                          reformId: valDetail.reformId || '',
                          reformPrice: valDetail.reformPrice || '',
                          avaiNumber: valDetail.reformNumber || currentRow.avaiNumber,
                          funnelCode: valDetail.funnelCode || ''
                        });
                      }

                    } else {
                      this.$msg.msge("未选择等级或无对应等级可选物料");
                    }
                  } catch (err) {
                    // console.error(`处理第${currentIndex + 1}条数据时出错：`, err);
                  }
                })();
              }
            },
            getDetailById(id){
              ss.loudnew.selectByFunnelIdXs(id).then(rd=>{
                console.log(rd)
                if(rd.f){
                  console.log(this.isSh,'isSh')
                  const products = rd.obj.products ? rd.obj.products.map(item => ({
                    materialDescrition: item.proModel,
                    proCode: item.proCode,
                    hid: item.proLevelOne,
                    avaiNumber: item.num,
                    // 补充表格必需的其他字段
                    productPrice: item.price || 0, // 基准价格（表格有此列，必须赋值）
                    tejiafangshi: this.isSh ? '1' : '2',
                    xianshizhehou: false,
                    // 3. 补充特价方式下拉框的数据源（空数组初始化，后续加载）
                    dingjialist: [],
                    bizhongjihe: [],
                    // 4. 补充定价相关字段（确保与全局赋值逻辑一致）
                    dingjia: '',
                    dingjiakexuan: true,
                    zhehoujine: '',
                  })) : [];

                  this.offer.xuanzhongren = rd.obj.agentName
                  let param = {
                    usercodename: rd.obj.agentName,
                    ddlx: 9,
                    pageNo: 1,
                    pageSize: 10
                  }
                  ss.selectUserAgent.cesuanselectUserAgentPage(param).then(res=>{
                    let obj = res.records[0]
                    this.shiyongrenxuanze(obj)
                    // 4. 【新增核心逻辑】：根据obj.province匹配salesregionListFilter，给offer.salesregion赋值
                    if (rd.obj.province && this.salesregionListFilter.length > 0) {
                      // 4.1 统一格式：去除省份字段空格，避免匹配偏差
                      const userProvince = (rd.obj.province || '').trim();

                      // 4.2 匹配规则：按“销售区域名称包含省份”匹配（可根据实际场景调整，如编码映射）
                      const matchedRegion = this.salesregionListFilter.find(region => {
                        return region.name && region.name.includes(userProvince);
                      });
                      // 4.3 匹配结果处理：成功赋值，失败提示
                      if (matchedRegion) {
                        this.offer.salesregion = matchedRegion.code; // 赋值销售区域编码（若需名称用matchedRegion.name）
                      } else {
                        this.offer.salesregion = ''; // 无匹配时清空
                      }
                    } else {
                      // 4.4 异常场景处理：无省份数据或销售区域列表为空
                      this.offer.salesregion = '';
                      if (!obj.province) {
                        console.warn('使用人数据中未包含province字段，无法匹配销售区域');
                      }
                      if (this.salesregionListFilter.length === 0) {
                        console.warn('销售区域列表为空，无法匹配，请先选择使用人');
                      }
                    }
                    // 3. 在  执行后，重新赋值产品数据
                    this.tableData3 = products;
                    this.tableData3.forEach(row => {
                      this.qiehuanjinezhekou(row); // 调用全局方法，同步显示控制
                    });

                    // 强制更新视图（确保数据渲染）
                    this.$forceUpdate();
                  })
                  this.offer.customerChannel =rd.obj.customerChannel
                  this.offer.toCompanyname = rd.obj.customerName
                  if (rd.obj.products && rd.obj.products.length) {
                    // 仅在数据有效时执行映射
                    this.tableData3 = rd.obj.products.map(item => ({
                      materialDescrition: item.proModel,
                      proCode: item.proCode,
                      hid: item.proLevelOne,
                      avaiNumber: item.num,
                      // 补充表格必需的其他字段
                      productPrice: item.price || 0, // 基准价格（表格有此列，必须赋值）
                      tejiafangshi: this.isSh ? '1' : '2',
                    }));
                    this.tableData3.forEach(row => {
                      this.qiehuanjinezhekou(row); // 再次同步状态
                    });
                    this.offer.type = '01'
                    this.offer.userCode = rd.obj.agentCode
                    this.getLoudDetail(this.tableData3)
                    // 映射后打印，确认结构正确
                    console.log("映射后的 tableData3：", this.tableData3);
                  } else {
                    console.warn("产品数据为空或格式错误");
                    this.tableData3 = []; // 避免 undefined 导致表格异常
                  }
                }
              })
            },
            //测算版本查看
            cesuanbanbenchakan() {

                //测算版本有的话
                if (this.cesuanid != null && this.cesuanid != '') {

                    var rversion = {

                        rversion: this.cesuanid
                    }

                    //查找测算版本
                    ss.FormulaNew.getbanben(rversion).then(rd => {

                        console.log(rd.obj, '测算')

                        //测算
                        this.neiwaixiaopanduan(rd.obj);

                    })

                }

            },


            //测算跳转判断
            neiwaixiaopanduan(q) {
                console.log(q, "asdasd????")

                var path = '';

                if (q.neixiaowaixiao == 1 && q.ispro == 1) { //外销项目
                    //跳转外销项目
                    path = '/xiangmu/entersix';

                } else if (q.neixiaowaixiao == 1 && q.ispro == 0) { //外销工具
                    //跳转外销工具
                    path = '/xiangmu/enterseven';

                } else if (q.neixiaowaixiao == 0) { //内销
                    //跳转内销测算
                    path = '/xiangmu/enterfive';

                } else if (q.neixiaowaixiao == 2) { //租赁
                    //跳转内销测算
                    path = '/rateFormulaZulinshiti';

                }

                var shiti = {
                    chakanshiti: q.rversion
                }

                console.log(shiti, 'shitishitishiti')


                let routeData = this.$router.resolve({path: path, query: shiti});
                window.open(routeData.href, '_blank');


            },


            kaishishifu(q) {

                console.log(q, '看看row')

                //如果是折扣
                if (q.tejiafangshi == '2') {

                    console.log(q, '看2222')

                    this.columndata = [{
                        prop: "zhehoujine",
                        label: "实付金额(特价*数量)",
                    }]

                    q.xianshizhehou = true;
                    q.xianshijine = false;

                }else if (q.tejiafangshi == '1') {

                    this.columndata = [{
                        prop: "zhehoujine",
                        label: "实付金额(特价*数量)",
                    }]

                    q.xianshizhehou = false;
                    q.xianshijine = true;

                }


            },


            xunzhaonengyongdengji(q) {

                var canshu = {

                    usercode: q,

                }

                ss.xinzengtejianew.xunzhaodengji(canshu).then(rd => {

                    console.log(rd, 'rffffgsss')

                    if (rd.obj.length <= 0) {

                        this.$msg.msge("该内销用户没有可用大类等级");

                    } else {

                        this.dengjixuanzelist = rd.xuanzelist;

                        this.nidmap = rd.nidmap;

                    }

                })

            },


            xuanzequyufangfa(q) {

                this.tableData3 = [];

                console.log(q, 'quyuquyu')

                console.log(this.offer.type, 'this.offer.type')


            },

            dblclick(v, h, c, d) {
                console.log(v, h, c, d, '???;;??')
            },


            //查看特价产品使用进度
            tejiachanpinshiyongqingkuang(index, q) {

                //跳转特价产品使用进度
                this.$router.push({path: '/price/priceToDetail', query: {id: q.id}})

            },

            //跟踪审批
            genzongLiuch() {

                this.showhistory = true;

            },


            //选择项目前监听使用人
            jiantingshiyongren(val) {

                console.log(val, 'aaawwwwsss')

                //如果是项目
                if (this.offer.category == 0 && !this.shenpiyemian && !this.bohuiyemian) {

                    if (this.xiangmumingchengOptions.length == 0) {

                        this.$msg.msge("使用人无相关项目或未选择使用人")

                    }

                }

            },

            //按用户usercode获取用户
            shiyongrenmingcheng(usercode) {

                var entity = {

                    usercode: usercode

                }

                ss.UserService.getByModel(entity).then(rd => {

                    console.log(rd.result, 'user')

                })

            },

            //通过或驳回 q: 1驳回，2通过
            tongguobohui(q) {

                console.log(this.offer.shenheyijian, 'this.offer.shenheyijian')

                //驳回
                if (q == 1) {

                    if (this.offer.shenheyijian != null && this.offer.shenheyijian != '') {

                        this.tijiaogengxinzhuangtai(q);

                    } else {

                        this.$msg.msge("请填写审批意见")

                    }

                    //通过
                } else if (q == 2) {

                    this.tijiaogengxinzhuangtai(q);

                }


            },

            //提交更新审核状态
            tijiaogengxinzhuangtai(q) {

                var sid = {
                    sid: this.rversion,
                    taskid: this.taskid,
                    optflag: q == 1 ? '驳回' : '通过',
                    msg: this.offer.shenheyijian,
                    tongguoorbohui: q,//通过还是驳回 1驳回  2通过

                }

                ss.specialController.tongguoshenhe(sid).then(rd => {
                    if (rd.f == true) {
                        this.$msg.alerts("提交成功！", () => {
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                           this.$router.go(-1);
                        })
                    }

                })
            },


            //重新提交
            chongxintijiao() {

                //判断一下高低价
               /* if (this.panduangaodijia()) {

                    this.$msg.alerte("低价特价版本请移步至: **盈利测算模块--工具版/海外工具版** 发起具体的测算申请，审批通过后将生成低价特价版本", () => {

                    })

                } else {*/

                    if (this.zancuntijiaobanben != null) {

                        var offer = {

                            specialId: this.zancuntijiaobanben

                        }

                        //先删除
                        ss.xinzengtejianew.luojishanchu(offer).then(rd => {

                            //若删除成功了
                            if (rd.f == true) {

                                // this.zancuntijiaobanben = this.$util.getUuid();

                                for (var d in this.tableData3) {

                                    this.tableData3[d].id = null;

                                }

                                //再提交
                                this.zancuntijiao(1);

                            }

                        })


                    }


                /*}*/


            },


            //审批加载
            shenpijiazai() {

                var ywid = {

                    ywid: this.rversion,

                }

                ss.xinzengtejianew.shenpijiazai(ywid).then(rd => {

                    console.log(rd.obj, "看看保存的")

                    if (rd.f == true) {

                        var val = {

                            username: rd.obj.username,
                            currency: 'CNY',
                            custagentgroup: 0 == rd.obj.leltypecode ? "0260" : 1 == rd.obj.leltypecode ? "0280" : null,
                            usercode: rd.obj.userCode,

                        }

                        //加载使用人选择信息
                        this.shiyongrenxuanze(val);

                        //加载信息
                        this.jiazaixinxi(rd.obj);

                    } else {
                        this.$router.back();

                        /*this.$router.push({path: '/pricenewN'})*/

                    }


                })

            },

            //加载信息
            jiazaixinxi(offer) {

                console.log(offer.shenpijindu, 'offer.shenpijindu')

                //是不是驳回的
                if (offer.bohui == 1) {

                    //是驳回
                    this.bohuiyemian = true;

                    //如果发现登陆人的节点其他人已经被驳回了直接跳转走
                    if (offer.tiaozhuango != null && offer.tiaozhuango == 1) {
                        this.$msg.msge("该审批已被驳回")
                        this.$router.push({path: "/personal/dealCenter"})
                    }

                    //不是驳回的话有业务id就是审批页面了
                } else if (this.ywid != null) {

                    //是审批页面
                    this.shenpiyemian = true;

                }

                //已经通过审批的就是正常查看页面
                if (offer.status == 2 && this.ywid == null) {

                    this.chakanyemian = true;

                    //已提交审批并且不是在审批或者驳回的页面上
                } else if (offer.bohui != 1 && (offer.status != 0 && offer.status != 2 && this.ywid == null)) {

                    this.yitijiaoshenpi = true;

                }


                //如果有instid就可以显示记录
                if (offer.instid != null) {

                    this.showhistoryid = offer.instid;

                }


                this.tableData3 = [];

                this.offer.category = offer.category;

                this.offer.userCode = offer.userCode;

                this.offer.xuanzhongren = offer.username;

                this.offer.cucode = offer.cucode;

                this.offer.cuname = offer.cuname;

                this.offer.cdate = offer.cdate;

                this.offer.pid = offer.pid;

                this.offer.youxiaoqi = [offer.startdate, offer.validity];

                this.offer.shenheyijian = this.bohuiyemian == true ? offer.shenpijindu != null ? offer.shenpijindu.split("_").length == 3 ? offer.shenpijindu.split("_")[2] : '' : '' : '';

                this.offer.tejiashuoming = offer.tejiashuoming;

                this.zancuntijiaobanben = offer.specialId;

                this.offer.leltypecode = offer.leltypecode;//海外0区域   /1 国内经销商级别

                this.offer.type = offer.type;//海外 区域   国内 级别

                this.offer.agentType = offer.agentType;//经销商国内/国外

                this.offer.isReform = offer.isReform;//是否改制

                this.offer.isFenxiao = offer.isFenxiao;//是否分销

                this.offer.contactAgentName = offer.contactAgentName;

                this.offer.salesregion = offer.salesregion;

                this.offer.contactAgent = offer.contactAgent;


                if (offer.fileid) {
                    this.fujianId = offer.fileid;//上传的附件
                } else {
                    this.fujianId = offer.specialId;//上传的附件
                }

                //存在测算转化版本
                if (offer.rversion) {

                    //测算版本
                    this.cesuanid = offer.rversion;

                    //显示测算查看
                    this.cesuanshow = true;

                    this.cailiaomaoli = offer.cesuanmap.cailiaomaoli;
                    this.jingyinggongxian = offer.cesuanmap.jingyinggongxian;
                    this.jingyinggongxianlv = offer.cesuanmap.jingyinggongxianlv;
                    this.lirun = offer.cesuanmap.lirun;
                    this.lirunlv = offer.cesuanmap.lirunlv;

                }


                //存在项目信息
                if (offer.proMain) {

                    //项目名称
                    this.offer.xiangmuname = offer.proMain.projectName;

                    //项目id
                    this.offer.xiangmucode = offer.proMain.id;

                    //显示项目信息
                    this.xiangmuxinxishow = true;

                    ss.ProService.proDetail(this.offer.xiangmucode).then(rd => {
                      console.log(rd, "项目列表");
                      console.log(this.proBidInfo);
                      this.formLabelAlign = rd;
                    });

                }

                if (offer.detailList != null && offer.detailList.length > 0) {

                    for (var d in offer.detailList) {

                        var list = {

                            leltypecode: offer.detailList[d].leltypecode,
                            type: offer.detailList[d].type,
                            id: offer.detailList[d].id,
                            proCode: offer.detailList[d].proCode,
                            proProductInfoid: offer.detailList[d].proProductInfoid,
                            hid: offer.detailList[d].hid,
                            materialDescrition: offer.detailList[d].materialDescrition,
                            tejiafangshi: offer.detailList[d].tejiafangshi,
                            jineorzhekou: offer.detailList[d].tejiafangshi == 1 ? offer.detailList[d].proDiscPrice : offer.detailList[d].tejiafangshi == 2 ? offer.detailList[d].proDiscount : "",
                            bizhong: offer.detailList[d].bizhong,
                            avaiNumber: offer.detailList[d].avaiNumber,
                            bizhongjihe: [],
                            dingjia: offer.detailList[d].dingjiaid ? offer.detailList[d].dingjiaid + "_" + (((offer.detailList[d].dingjia + "").split(".").length > 1) ? offer.detailList[d].dingjia : (offer.detailList[d].dingjia + ".0")) : offer.detailList[d].dingjia,
                            dingjiaid: offer.detailList[d].dingjiaid ? offer.detailList[d].dingjiaid : null,
                            dingjialist: offer.detailList[d].dingjialist || null,
                            dingjiakexuan: true,
                            xianshizhehou: false,
                            xianshijine: false,
                            zhehoujine: '',
                            baofei:offer.detailList[d].baofei || null,
                            yongjin:offer.detailList[d].yongjin || null,
                            yunfei:offer.detailList[d].yunfei || null,
                            reformId:offer.detailList[d].reformId,
                            reformPrice:offer.detailList[d].reformPrice,

                            fenxiaoPrice:offer.detailList[d].fenxiaoPrice || null,
                            fenxiaoMaori:offer.detailList[d].fenxiaoMaori || null,
                            agentMaori:offer.detailList[d].agentMaori || null,
                            applyPrice:offer.detailList[d].applyPrice || null,
                            biddenPrice:offer.detailList[d].biddenPrice || null,
                        }


                        for (var t in this.bizhongListops) {

                            if (this.bizhongListops[t].code == offer.detailList[d].bizhong) {

                                list.bizhongjihe.push({

                                    label: this.bizhongListops[t].name,
                                    value: offer.detailList[d].bizhong,

                                })

                            }

                        }


                        this.tableData3.push(list);
                        this.kaishishifu(list);

                    }

                }


                //是项目的话
                if (offer.category == 0) {

                    console.log("走没走这个", "aa")

                    //加载项目名称下拉选框
                    this.anrenyuanxuanzexiangmu(offer.userCode);

                    //加载项目产品
                    this.xiangmumingchengchangetype(offer.pid);

                }

                console.log(this.tableData3, 'this.tableData3')


            },

            //普通加载
            putongjiazai() {

                //版本id设置
                // this.zancuntijiaobanben = this.$util.getUuid();

                //上传附件编码
                this.fujianId = this.$util.getUuid();

            },

            //切换金额折扣
            qiehuanjinezhekou(row) {
                //如果是折扣
                if(row.tejiafangshi == '2'){
                    row.xianshizhehou = true;
                    row.xianshijine = false;
                }
                if(row.tejiafangshi == '1'){
                    row.xianshizhehou = false;
                    row.xianshijine = true;
                }

                row.jineorzhekou = 0;
                console.log(row, 'rowppp')

            },

            //选择币种时同时加载对应币种定价
            jiazaidingjia(val) {

                //如果已经获取过定价了就不查了
                if(val.dingjia != null && val.dingjia != ''){
                    return;
                }

                console.log(val, '有没有')

                var entity = {

                    materialid: val.proCode,//物料号
                    currency: 'CNY',

                }

                if (this.offer.category != 4 || this.offer.userCode) {

                    entity.type = this.offer.type;//使用人的区域编码或者级别
                    entity.leltypecode = this.offer.leltypecode;//区域0  级别1

                }

                //如果没选区域先选区域
                if ((this.offer.category != 4 || this.offer.userCode) && (this.offer.type == null || this.offer.type == '')) {

                    this.$msg.msge("请选择区域")

                    val.bizhong = '';

                } else {

                    console.log(entity, 'entityaaa')
                    entity.category = this.offer.category;
                    entity.usercode = this.offer.userCode;
                    ss.xinzengtejianew.finddingjia(entity).then(rd => {

                        console.log(rd.obj, 'uuuu')

                        var dingjialist = []

                        for (var d in rd.obj) {

                            if(this.offer.category==5 && val.tejiafangshi==1){

                                if(this.offer.isReform){
                                    console.log("val",val)
                                    val.jineorzhekou = parseFloat(rd.obj[d].value)+parseFloat(val.reformPrice);

                                    //1如果是改制单 判断金额是否大于 基准价+改制加价
                                    if(val.jineorzhekou<parseFloat(rd.obj[d].value)+parseFloat(val.reformPrice)) {
                                        this.$msg.msge("特价类型为高价订单时，金额不得低于标准价格加单台加价:"+(parseFloat(rd.obj[d].value)+parseFloat(val.reformPrice)))
                                    }
                                }
                                if(val.jineorzhekou<rd.obj[d].value) {
                                    this.$msg.msge("特价类型为高价订单时，金额不得低于标准价格")
                                }

                            }
                            if((this.offer.category==3 || this.offer.category==4) && val.tejiafangshi==1){
                                if(val.jineorzhekou>rd.obj[d].value) {
                                    this.$msg.msge("特价类型为台阶政策或特殊直扣时，金额不得高于标准价格")

                                }
                            }
                     /*       if((this.offer.category==3 || this.offer.category==4 || this.offer.category==5) && val.tejiafangshi==1){
                                if(val.jineorzhekou==rd.obj[d].value) {
                                    this.$msg.msge("金额不得等于标准价格")

                                }
                            }*/
                            if(rd.obj[d].materialid == entity.materialid && rd.obj[d].type == entity.type &&
                                rd.obj[d].currency == entity.currency ){
                                dingjialist.push({
                                    label: rd.obj[d].value,
                                    value: rd.obj[d].id + "_" + rd.obj[d].value,
                                    jine: rd.obj[d].value,

                                })
                            }



                        }

                        console.log(dingjialist, 'dingjialist')

                        val.dingjialist = dingjialist;
                        console.log(val.dingjialist, 'val.dingjialist')

                        console.log(this.tableData3, 'tableData3')

                        //若只有一个可用定价，默认选中
                        if (dingjialist.length == 1) {

                            val.dingjia = dingjialist[0].value;
                            val.dingjiakexuan = true;

                            //没有定价
                        } else if (dingjialist.length == 0) {

                            this.$msg.msge("该币种无对应定价，请重新选择")

                            val.bizhong = '';

                            val.dingjia = '';

                            val.dingjialist = [];

                            //todo 曹经理让只要有有效期内重复的定价，先默认只选中一条 20191225
                        } else if (dingjialist.length > 1) {

                            val.dingjia = dingjialist[0].value;
                            val.dingjiakexuan = true;

                        }

                    })

                }


            },


            //项目产品选择
            chanpincodechange(val) {

                console.log(val, '+++产品')

                console.log(this.xiangmuchanpinmap[val.proProductInfoid], '???')

                val.avaiNumber = this.xiangmuchanpinmap[val.proProductInfoid].productNum;
                val.hid = this.xiangmuchanpinmap[val.proProductInfoid].type;
                val.bizhong = this.xiangmuchanpinmap[val.proProductInfoid].currency || this.shiyongrenbizhong;
                val.materialDescrition = this.xiangmuchanpinmap[val.proProductInfoid].productName;
                val.proCode = this.xiangmuchanpinmap[val.proProductInfoid].productId;
                val.dingjia = this.xiangmuchanpinmap[val.proProductInfoid].productPrice;

                console.log(this.bizhongListops, 'this.bizhongListops')

                console.log(this.xiangmuchanpinmap, 'this.xiangmuchanpinmap')

                for (var t in this.bizhongListops) {

                    if (this.bizhongListops[t].code == val.bizhong) {

                        val.bizhongjihe.push({

                            label: this.bizhongListops[t].name,
                            value: val.bizhong,

                        })

                    }
                }


            },

            //弹出选择物料
            tanchuwuliao() {
                this.xuanwuliao = true;
            },

            //判断物料是否能被选中
            shifouxuanzhong(val) {

                //是否能选中
                var yes = false;

                //若是特殊直扣
                if (this.offer.category == 3 || this.offer.category == 5 || (this.offer.category == 4 && this.offer.userCode)) {

                    //遍历级别:(大类集合)
                    for (var m in this.nidmap) {

                        //如果有跟现在选择的级别一致的级别
                        if (this.offer.type == m) {

                            //遍历大类集合
                            for (var f in this.nidmap[m]) {

                                //若该选中物料的大类在集合中存在  或者大类集合中存在ct可全选
                                if ((val.cpdlcode == this.nidmap[m][f]) || this.nidmap[m][f] == 'ct') {

                                    //设为可选中
                                    yes = true;

                                }

                            }

                        }

                    }


                }

                return yes;

            },

            //选择产品型号的方法
            chanpinxinghaochangetype(val) {
                console.log(val, '+++物料')
                console.log(this.offer.category, 'category')
                if (this.offer.category != 3 || this.xuanzedengji == true ? this.shifouxuanzhong(val) : true) {
                    //目前选择产品判断放在后台，无需在前台判断，所以去掉后面 --0621 zfl
                    // if (this.offer.category != 3 || this.xuanzedengji == true) {

                    var ind = [val.matecode]

                    ss.xinzengtejianew.findkexuanwuliao(ind).then(rd => {

                        console.log(rd.obj, 'obj2222')

                        var bizhongjihe = [];

                        for (var c in rd.obj) {

                            for (var cc in rd.obj[c]) {

                                for (var d in this.bizhongListops) {

                                    if (rd.obj[c][cc].currency == this.bizhongListops[d].code) {

                                        if (this.shiyongrenbizhong && this.shiyongrenbizhong == rd.obj[c][cc].currency) {

                                            bizhongjihe.push({
                                                label: this.bizhongListops[d].name,
                                                value: rd.obj[c][cc].currency,
                                            })

                                        } else if (!this.shiyongrenbizhong) {

                                            bizhongjihe.push({
                                                label: this.bizhongListops[d].name,
                                                value: rd.obj[c][cc].currency,
                                            })

                                        }


                                    }

                                }


                            }

                        }
                        console.log("val.reformId",val.reformId)
                        this.tableData3.push({
                            proCode: rd.obj[c][0].materialid,
                            hid: rd.obj[c][0].hidSystem || rd.obj[c][0].hidMdm,
                            materialDescrition: rd.obj[c][0].materialdescritionSystem || rd.obj[c][0].materialdescritionMdm,
                            tejiafangshi: this.isSh?'1':'2',
                            jineorzhekou: '',
                            bizhong: 'CNY',
                            avaiNumber: '',
                            bizhongjihe: bizhongjihe,
                            dingjialist: [],
                            xianshizhehou: false,
                            xianshijine: false,
                            zhehoujine: '',
                            //改制单相关
                            reformId: val.reformId,
                            reformPrice: val.reformPrice,
                            avaiNumber:val.reformNumber,
                            factory:val.factory,

                        })
                        let newItem = this.tableData3[this.tableData3.length - 1];
                        this.jiazaidingjia(newItem);
                        console.log(this.tableData3, 'this.tableData3')


                    })


                } else {

                    this.$msg.msge("未选择等级或无对应等级可选物料")

                }

                this.xuanwuliao = false;

            },


            //特价类型选择
            tejialeixingxuanze(val) {


                this.offer.type = '';

                this.offer.leltypecode = '';

                this.offer.userCode = '';

                this.tableData3 = [];

                this.offer.xuanzhongren = '';

                this.offer.pid = '';

              this.offer.salesregion = '';

                this.xiangmumingchengOptions = [];

                this.offer.isReform = false;

                console.log(val, 'aa')


                if (val == null) {

                    this.offer.category = null;

                }

                //项目特价
                if (val && val.code == 0) {


                    //特殊直扣
                } else if (val && val.code == 3) {


                    //台阶政策
                } else if (val && val.code == 4) {

                    //加载可选物料
                    this.jiazaikexuanwuliao(null);

                }

            },

            //返回上页
            fanhuishangye() {

                //跳转
                this.$router.back();

            },

            // 补传确认
            async confirmSupplement() {
                try {
                    const res = await lkService.supplementUpload({ specialId: this.rversion || this.offer.specialId });
                    if (res && res.f == true && res.obj) {
                        const data = res.obj;
                        if (data.allUploaded) {
                            this.$msg.alerts("补传完成，所有文件已上传", () => {
                                this.$router.back();
                            });
                        } else {
                            const missing = data.missingTypes ? data.missingTypes.join('、') : '';
                            this.$msg.alerts("以下文件尚未上传：" + missing, () => {
                                this.$router.back();
                            });
                        }
                    }
                } catch (e) {
                    console.error("补传失败", e);
                }
            },


            //判断重复信息
            panduanchongfuxinxi() {

                //todo
                return false
            },


            //判断特殊直扣的高低价
            panduangaodijia() {

                var yes = false;

                //特殊直扣
                if (this.offer.category == 3||this.offer.category == 5 || (this.offer.category == 4 && this.offer.userCode)) {


                    for (var s in this.tableData3) {

                        var fangshi = this.tableData3[s].tejiafangshi;
                        var jine = this.tableData3[s].jineorzhekou;
                        var dingjia = ((/^\w*_\d*.*\d*$/.test(this.tableData3[s].dingjia)) ? this.tableData3[s].dingjia.split("_")[1] : this.tableData3[s].dingjia);

                        //金额
                        if (fangshi == '1') {

                            if (parseFloat(jine) < parseFloat(dingjia)) {

                                yes = true;

                            }

                            //折扣
                        } else if (fangshi == '2') {

                            if (parseFloat(jine) < 1.0) {

                                yes = true;

                            }

                        }


                    }

                }

                return yes;

            },


            //暂存或提交
            async zancuntijiao(q) {

                //判断一下高低价
                // if (this.panduangaodijia()) {
                //
                //     this.$msg.alerte("低价特价版本请移步至: **盈利测算模块--工具版/海外工具版** 发起具体的测算申请，审批通过后将生成低价特价版本", () => {
                //
                //     })
                //
                // } else {

                if (this.tableData3.length > 0) {

                    //判断数据完整和正数和小数
                    var yes = this.panduanxiaoshu();

                    //若有不符合输入的
                    if (yes) {

                        //判断折扣输入是否标准
                        if (this.zhekoupanduan) {
                            this.$msg.msge("折扣必须输入小数")

                            //判断其他输入是否标准
                        } else {
                            this.$msg.msge('请输入正确的特价信息')
                        }

                        //没问题的
                    } else {

                        console.log(this.tableData3, '提交数据')
                        //判断价格录入是否符合要求
                        for (var c in this.tableData3) {
                            var data = this.tableData3[c];
                            //如果是高价订单,折扣不可小于1
                            if (this.offer.category == 5 && data.tejiafangshi == 2){
                                if(data.jineorzhekou <= 1){
                                    this.$msg.msge("特价类型为高价订单时，折扣额度不可小于1")
                                    return;
                                }
                            }
                            if(this.offer.category==5 && data.tejiafangshi==1){
                                //如果是改制单 判断金额是否大于 基准价+改制加价
                                if(this.offer.isReform){
                                    console.log(data, 'data')
                                    console.log("data.dingjialiste",parseFloat(data.dingjialist[0].jine)+parseFloat(data.reformPrice));
                                    if(parseFloat(data.jineorzhekou)+parseFloat(data.reformPrice)<parseFloat(data.dingjialist[0].jine)+parseFloat(data.reformPrice)) {
                                        this.$msg.msge("特价类型为高价订单时，金额不得低于标准价格加单台加价:"+(parseFloat(data.dingjialist[0].jine)+parseFloat(data.reformPrice)))
                                        return;
                                    }
                                }

                                if(parseFloat (data.jineorzhekou)<parseFloat (data.dingjialist[0].jine)) {
                                    this.$msg.msge("特价类型为高价订单时，金额不得低于标准价格")
                                    return;
                                }

                            }
                            if((this.offer.category==3 || this.offer.category==4) && data.tejiafangshi==1){
                                if(data.jineorzhekou>data.dingjialist[0].jine) {
                                    this.$msg.msge("特价类型为台阶政策或特殊直扣时，金额不得高于标准价格")
                                    return;
                                }
                            }
                            /*   if((this.offer.category==3 || this.offer.category==4 || this.offer.category==5) && data.tejiafangshi==1){
                                   if(data.jineorzhekou==data.dingjialist[0].jine) {
                                       this.$msg.msge("金额不得等于标准价格")
                                       return;
                                   }
                               }*/
                        }



                        //todo 判断重复
                        var shifouchongfu = this.panduanchongfuxinxi();

                        //若有重复或无效的
                        if (shifouchongfu) {
                            this.$msg.msge("有重复及无效信息请修改")
                            //没问题的
                        } else {

                            // 提交时校验必传文件（高价订单category=5仅含改制申请单且非必填, 跳过校验, 2026.07）
                            if (q == 1 && this.offer.category != 5) {
                                try {
                                    const fileRes = await lkService.getFileStatus(this.fujianId)
                                    if (fileRes && fileRes.f == true && fileRes.obj) {
                                        const status = fileRes.obj
                                        if (!status.lk_sqdan) {
                                            this.$msg.msge("请上传项目特价申请单")
                                            return
                                        }
                                        if (!status.lk_chengno) {
                                            this.$msg.msge("请上传项目特价承诺书")
                                            return
                                        }
                                        if (!status.lk_hetong) {
                                            this.$msg.msge("请上传中标合同")
                                            return
                                        }
                                    }
                                } catch (e) {
                                    console.error('文件校验失败', e)
                                }
                            }

                            // 朗康逾期校验（校验对阵代理商, 2026.07由使用人改为对阵代理商）
                            const overdueCheck = await lkService.checkOverdue(this.offer.contactAgent)
                            if (overdueCheck && overdueCheck.obj && !overdueCheck.obj.pass) {
                                this.$msg.alerte(overdueCheck.obj.msg || "该代理商存在逾期未补全资料的特价申请，无法新增")
                                return
                            }

                            //暂存
                            if (q == 0) {

                                //暂存
                                this.zancuntongdao(q);

                                //提交
                            } else if (q == 1) {

                                //提交
                                this.tijiaotongdao(q);

                            }

                        }

                    }

                } else {

                    this.$msg.msge('请先添加特价信息')

                }

                // }


            },


            //暂存按钮
            zancuntongdao(q) {

                //创建暂存
                ss.xinzengtejianew.chuangjiantejia(this.gouzaocanshu(q)).then(rd => {

                    console.log(rd.obj, 'kankanfanhui')

                    if (rd.f == true) {

                        this.$msg.msgs("保存成功")
                        this.$router.push("/pricenewLK");

                    }

                })

            },


            //逻辑删除
            luojishanchu(specialId, ids) {

                var offer = {}

                if (specialId != null) {

                    offer.specialId = specialId;

                }

                if (ids != null && ids.length > 0) {

                    var detaillist = []

                    for (var i in ids) {

                        detaillist.push({

                            id: ids[i]

                        })

                    }

                    offer.detaillist = detaillist;

                }


                //逻辑删除
                ss.xinzengtejianew.luojishanchu(offer).then(rd => {

                })


            },


            //构造参数
            gouzaocanshu(q) {
                var offer = {
                    specialId: this.rversion == null ?null : this.rversion,
                    pid: this.offer.category == 0 ? this.offer.pid : null,
                    category: this.offer.category,
                    startdate: this.offer.youxiaoqi == null ? null : (this.offer.youxiaoqi[0] == '' || this.offer.youxiaoqi[0] == null) ? '' : this.$util.riQi(this.offer.youxiaoqi[0]),
                    validity: this.offer.youxiaoqi == null ? null : (this.offer.youxiaoqi[1] == '' || this.offer.youxiaoqi[1] == null) ? '' : this.$util.riQi(this.offer.youxiaoqi[1]),
                    status: q,
                    tejiashuoming: this.offer.tejiashuoming,
                    userCode: this.offer.userCode || null,
                    userCatecory: 1,
                    bohui: 0,
                    fileid: this.fujianId,
                    isShTj: this.isSh?'1':null,
                    isFwTj: this.isFw?'1':null,
                    serviceProductsType:'3Q服务类',
                    //是否改制单
                    isReform :this.offer.isReform,
                    //经销商类型 1内销3外销
                    agentType:this.offer.agentType,

                    contactAgent:this.offer.contactAgent,
                    contactAgentName:this.offer.contactAgentName,
                    salesregion:this.offer.salesregion,

                    isLk: true,

                }

                var detaillist = []

                for (var d in this.tableData3) {

                    console.log("this.tableData3[d]", this.tableData3[d])

                    detaillist.push({

                        id: this.tableData3[d].id || null,
                        // sid: this.zancuntijiaobanben,
                        pid: this.offer.category == 0 ? this.offer.pid : null,
                        proCode: this.tableData3[d].proCode,
                        leltypecode: this.offer.leltypecode,
                        type: this.offer.type,
                        proProductInfoid: this.offer.category == 0 ? this.tableData3[d].proProductInfoid : null,
                        tejiafangshi: this.tableData3[d].tejiafangshi,
                        proDiscPrice: this.tableData3[d].tejiafangshi == 1 ? this.tableData3[d].jineorzhekou : null,
                        proDiscount: this.tableData3[d].tejiafangshi == 2 ? this.tableData3[d].jineorzhekou : null,
                        bizhong: this.tableData3[d].bizhong,
                        avaiNumber: this.tableData3[d].avaiNumber,
                        totalNumber: this.tableData3[d].avaiNumber,
                        upfilenames: this.zhengmingziliao,
                        dingjiaid: this.offer.category == 0 ? null : this.tableData3[d].dingjia.split("_")[0],
                        dingjia: this.offer.category == 0 ? this.tableData3[d].dingjia : this.tableData3[d].dingjia.split("_")[1],
                        //改制流水号
                        reformId: this.tableData3[d].reformId || null,
                        baofei: this.tableData3[d].baofei || null,
                        yongjin: this.tableData3[d].yongjin || null,
                        yunfei: this.tableData3[d].yunfei || null,
                        reformPrice: this.tableData3[d].reformPrice || null,

                    })

                }


                offer.detailList = detaillist;

                console.log(offer, 'offer')

                return offer
            },


            //提交通道
            tijiaotongdao(q) {

                //提交
                ss.xinzengtejianew.tejiaotejia(this.gouzaocanshu(q)).then(rd => {

                    console.log(rd.obj, 'kankanfanhui')

                    if (rd.f == true) {
                        this.$msg.alerts("提交成功！", () => {
                            this.$router.push({path: '/pricenewLK'});
                        })
                    }


                })


            },


            //判断数据完整和正数和小数
            panduanxiaoshu() {
                this.zhekoupanduan = false;
                let yes = false;
                // 存放所有错误信息
                let errorList = [];
                // 跳过校验的字段
                const skipFieldArr = [
                    'dingjiaid','id','bizhongjihe','proProductInfoid','dingjialist',
                    'xianshizhehou','xianshijine','zhehoujine','yongjin','baofei','yunfei',
                    'reformId','reformPrice','reformIdList','funnelCode','fenxiaoPrice','fenxiaoMaori',
                    'agentMaori','applyPrice','biddenPrice'
                ];

                for (let c in this.tableData3) {
                    let row = this.tableData3[c];
                    let rowIndex = Number(c) + 1; // 展示行号，更直观

                    for (let f in row) {
                        let fieldVal = row[f];
                        // ========== 1、非空校验 ==========
                        if (!skipFieldArr.includes(f)) {
                            // 拆分原混乱的多条件，修复优先级问题
                            let emptyCheckPass = true;
                            // 条件A：品类不是4，当前字段为空 或 avaiNumber=0
                            if (this.offer.category !== 4) {
                                if (fieldVal == null || fieldVal === '') {
                                    errorList.push(`第${rowIndex}行【${f}】字段不能为空`);
                                    emptyCheckPass = false;
                                }
                                if (row.avaiNumber == 0) {
                                    errorList.push(`第${rowIndex}行 avaiNumber可用数量不能为0`);
                                    emptyCheckPass = false;
                                }
                            }
                            // 条件B：核心定价字段异常
                            if (row.jineorzhekou == 0) {
                                errorList.push(`第${rowIndex}行 jineorzhekou金额不能等于0`);
                                emptyCheckPass = false;
                            }
                            if (row.dingjia == null || row.dingjia === '') {
                                errorList.push(`第${rowIndex}行 dingjia定价不能为空`);
                                emptyCheckPass = false;
                            }
                            if (!emptyCheckPass) yes = true;
                        }

                        // ========== 2、销量avaiNumber数字校验 ==========
                        if (f === 'avaiNumber' && this.offer.category !== 4) {
                            // 正则：正整数或正小数  修复原 . 未转义BUG
                            let regNum = /^\d+(\.\d+)?$/;
                            if (!regNum.test(fieldVal)) {
                                errorList.push(`第${rowIndex}行【avaiNumber销量】格式错误，只能输入正数/小数`);
                                yes = true;
                            }
                        }

                        // ========== 3、折扣校验 tejiafangshi=2 ==========
                        if (f === 'jineorzhekou' && row.tejiafangshi == 2) {
                            // 折扣格式：0.xx 0.1~0.99 修复正则
                            let regZhekou = /^[0-9].\d+$/;
                            if (!regZhekou.test(fieldVal)) {
                                errorList.push(`第${rowIndex}行【jineorzhekou折扣】格式错误，需0.开头小数`);
                                yes = true;
                                this.zhekoupanduan = true;
                            }
                        }

                        // ========== 4、金额校验 tejiafangshi=1 ==========
                        if (f === 'jineorzhekou' && row.tejiafangshi == 1) {
                            // 正整数 或 正小数
                            let regMoney = /^\d+(\.\d+)?$/;
                            if (!regMoney.test(fieldVal)) {
                                errorList.push(`第${rowIndex}行【jineorzhekou金额】格式错误，只能输入正数`);
                                yes = true;
                            }
                        }
                    }
                }

                // ========== 5、外层offer有效期校验 ==========
                if (this.offer.category !== 4) {
                    let qx = this.offer.youxiaoqi;
                    if (qx == null || qx === '' || qx.length < 2 || !qx[0] || !qx[1]) {
                        errorList.push(`报价单【有效期】不能为空，需填写起止日期`);
                        yes = true;
                    }
                }

                // ========== 6、特价说明校验 ==========
                if (this.offer.category == 4 && this.offer.tejiashuoming == null) {
                    errorList.push(`特价品类【特价说明】不能为空`);
                    yes = true;
                }

                // 打印全部错误信息，精准定位
                if (errorList.length > 0) {
                    console.log("校验失败明细：", errorList.join("；\n"));
                    // 如需弹窗提示直接放开
                    // this.$message.error("校验失败：" + errorList.join("；"));
                }

                return yes;
            },

            //币种加载
            bizhongjiazai() {


                ss.Dictservice.listbycategory("YLCurrency").then(rd => {

                    console.log(rd, '字典结果')
                    this.bizhongListops = rd;

                })

            },

            changeSalesregion(){
              //进行强制数据渲染
              this.$forceUpdate();
            },
            //加载可选物料
            jiazaikexuanwuliao(q) {

                var qer = [];

                if (q != null) {

                    qer = q;

                }

                this.wuliaocode = [];

                //获取可以选择的物料map
                ss.xinzengtejianew.findkexuanwuliao(qer).then(rd => {

                    console.log(rd.obj, 'obj')

                    this.kexuanwuliao = rd.obj;

                    for (var c in rd.obj) {

                        if (rd.obj[c][0].materialdescritionSystem) {

                            this.wuliaocode.push({

                                value: c,
                                label: rd.obj[c][0].materialdescritionSystem,

                            })

                        } else if (rd.obj[c][0].materialdescritionMdm) {

                            this.wuliaocode.push({

                                value: c,
                                label: rd.obj[c][0].materialdescritionMdm,

                            })

                        }

                    }

                })

            },


            //台阶政策切换物料的方法
            wuliaocodechange(q) {

                q.bizhong = null;

                console.log(q, 'row')

                for (var c in this.kexuanwuliao) {

                    if (c == q.proCode) {

                        q.materialDescrition = this.kexuanwuliao[c][0].materialdescritionSystem ? this.kexuanwuliao[c][0].materialdescritionSystem : this.kexuanwuliao[c][0].materialdescritionMdm ? this.kexuanwuliao[c][0].materialdescritionMdm : '';
                        q.hid = this.kexuanwuliao[c][0].hidSystem ? this.kexuanwuliao[c][0].hidSystem.substr(0, 3) : this.kexuanwuliao[c][0].hidMdm ? this.kexuanwuliao[c][0].hidMdm.substr(0, 3) : '';

                        var bizhongjihe = [];

                        for (var t in this.kexuanwuliao[c]) {

                            for (var d in this.bizhongListops) {

                                if (this.kexuanwuliao[c][t].currency == this.bizhongListops[d].code) {

                                    bizhongjihe.push({
                                        label: this.bizhongListops[d].name,
                                        value: this.kexuanwuliao[c][t].currency,
                                    })

                                }

                            }


                        }

                        q.bizhongjihe = bizhongjihe;


                    }

                }


            },


            //切换项目名称的方法
            xiangmumingchengchangetype(val) {

                console.log(val, 'pid');

                var pid = {

                    pid: val

                }

                //获取项目对应项目产品
                ss.xinzengtejianew.findxiangmuchanpin(pid).then(rd => {

                    this.xiangmuchanpinmap = rd.obj;

                    console.log(rd.obj, 'rd.obj')

                    for (var t in rd.obj) {

                        this.chanpincode.push({

                            label: rd.obj[t].productName,
                            value: t,

                        })


                    }


                })

            },
            //选择是否改制
            changeReform(){
                //清空项目列表
                this.tableData3=[];
            },

            tanchuxuanzeren() {
                this.offer.type = '';
                if (this.isSh) {
                    this.showshdfdialog = true;
                } else {
                    this.xuanzeren = true;
                }
                // dialogFormVisible
            },
            //选择使用人
            shiyongrenxuanze(val) {
                console.log(val, '+++使用人')
                this.xuanzeren = false;
                this.showshdfdialog = false;
                this.offer.userCode = val.usercode;
                this.offer.xuanzhongren = val.username;
                this.offer.agentType = val.agenttype;
                // 选择人员，清空项目列表
                this.tableData3=[];

                this.offer.leltypecode = "0260" == val.custagentgroup ? 0 : "0280" == val.custagentgroup || "0230" == val.custagentgroup || "0210" == val.custagentgroup? 1 : null;//海外0区域   /1 国内经销商级别
                // this.offer.type = "0260" == val.custagentgroup ? '' : "0280" == val.custagentgroup ? val.jxsjb : null;//海外 区域   国内 级别
                this.shiyongrenbizhong = val.currency;//使用人的币种

                //是否选区域
                this.xuanzequyu = "0260" == val.custagentgroup ? true : false;

                //是否选等级
                this.xuanzedengji = "0280" == val.custagentgroup ||  "0230" == val.custagentgroup || "0210" == val.custagentgroup ? true : false;

                this.salesregionListFilter = _.filter(this.salesregionList,(o) => {
                  return _.split(val.salesregion || '', ",").includes(o.code);
                });

                if ("0280" == val.custagentgroup || "0230" == val.custagentgroup || "0210" == val.custagentgroup) {

                    //加载能选等级
                    this.xunzhaonengyongdengji(val.usercode);

                }
                //判断是不是厚宏的代理商或平台商
                this.getHhAgent(val.usercode);


                //换项目
                this.anrenyuanxuanzexiangmu(val.usercode);
            },


            //按人员选项目
            anrenyuanxuanzexiangmu(q) {
                this.xiangmumingchengOptions = [];
                var id = {
                    id: q
                }
                ss.specialController.anrennaxiangmu(id).then(rd => {
                    console.log(rd.obj, '看看有啥')
                    //加载项目名称下拉选框
                    for (var ss in rd.obj) {
                        var cus = {
                            value: rd.obj[ss].id,
                            label: rd.obj[ss].projectName,
                        }
                        this.xiangmumingchengOptions.push(cus);
                    }
                })
            },
            //是不是厚宏的代理商
            getHhAgent(agentCode) {
                ss.specialController.getHhAgent(agentCode).then(rd => {
                    console.log(rd.msg, '看看有啥')
                    if(rd.msg != 0){
                        this.contactAgentList = rd.msg;
                        this.hhdls = true;
                    }else {
                        this.hhdls = false;
                    }
                })
            },

            changeAgent (value) {
                console.log(value)
                this.offer.contactAgent = value.agentCode;
                this.offer.contactAgentName = value.agentName;
            },


            //逻辑删除特价产品
            shanchuchanpinfangfa(q) {

                var entity = {

                    id: q,
                    delflag: 0,

                }

                ss.specialController.luojishanchuchanpin(entity).then(rd => {

                    if (rd.f == true) {

                        this.$msg.msgs("删除成功")

                    }

                })

            },


            //删除框
            delPlan(index, q) {

                console.log(q, 'qaaaaa')

                this.$confirm('确认删除？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                })
                    .then(_ => {

                        //如果原来有数据
                        if (q.id != null) {//把要删除的主键id存起来
                            this.yaoshanchude.push({id: q.id});

                            //查看页面
                            if (this.chakanyemian == true) {

                                //逻辑删除特价产品
                                this.shanchuchanpinfangfa(q.id);

                            }

                        }
                        this.tableData3.splice(index, 1)
                        //console.log(index,"删除一行数据");

                    })
                    .catch(_ => {

                    });

            },


            expoType(v) {
                if (v.expoType == "1") {
                    v.expoPrice = "";
                } else {
                    v.expoDiscount = "";
                }
            },
            // //表格 只能输入数字方法
            // onlynumber(scope){
            // 	let ex = /^[1-9][0-9]*$/
            // 	if(ex.test(scope.amount)){
            //
            // 	}else{
            // 		scope.amount = 1;
            // 	}
            // },

            addfilecallbackpo() {
            },
            delIndex(index) {
            },


            //增加行
            adds() {

                console.log(this.offer, 'this.offer')

                //特殊直扣,(台阶政策选择了使用人)
                if (this.offer.category == 3 ||this.offer.category == 5 || (this.offer.category == 4 && this.offer.userCode)) {

                    //若已选使用人code
                    if (this.offer.userCode) {

                      if(!this.offer.salesregion){
                        this.$msg.msge("请先选择销售区域!")
                      }else {
                        //弹出物料选择框
                        this.tanchuwuliao();
                      }

                        //若没选
                    } else {

                        this.$msg.msge("请先选择特价使用人")

                    }


                    //台阶政策
                } else if (this.offer.category == 4) {

                  if(!this.offer.salesregion){
                    this.$msg.msge("请先选择销售区域!")
                  }else {
                    var list = {
                      proCode: '',
                      hid: '',
                      materialDescrition: '',
                      tejiafangshi: '2',
                      jineorzhekou: '',
                      bizhong: '',
                      avaiNumber: '',
                      bizhongjihe: [],
                      dingjialist: [],
                      xianshizhehou: false,
                      zhehoujine: '',
                    }


                    this.tableData3.push(list)
                  }
                    //项目
                } else if (this.offer.category == 0) {

                    if (this.offer.pid == null || this.offer.pid == '') {

                        this.$msg.msge("请选择项目")

                    } else {

                      if(!this.offer.salesregion){
                        this.$msg.msge("请先选择销售区域")
                      }else {
                        var list = {
                          proCode: '',
                          proProductInfoid: '',
                          hid: '',
                          materialDescrition: '',
                          tejiafangshi: '',
                          jineorzhekou: '',
                          bizhong: '',
                          avaiNumber: '',
                          bizhongjihe: [],
                          dingjialist: [],
                          xianshizhehou: false,
                          zhehoujine: '',
                        }


                        this.tableData3.push(list)
                      }

                    }

                }


            },

            //时间限制
            beginDate(v) {
                if (v.purchaseDate) {  //如果结束时间不为空，则小于结束时间
                    if (v.purchaseDate < v.exfactoryDate) {
                        this.$msg.msge("购买日期不能小于出厂日期");
                        v.exfactoryDate = "";
                    }
                }
            },
            processDate(v) {
                if (v.exfactoryDate) {//如果有出厂日期
                    //如果购买日期小于出厂日期
                    if (v.purchaseDate < v.exfactoryDate) {
                        this.$msg.msge("购买日期不能小于出厂日期");
                        v.purchaseDate = "";
                    }
                }
            }
        },
    }
</script>


<style scoped>

    .n-bu .el-input--suffix .el-input__inner {
        padding-left: 45px;
    }

    .n-bu .h-formbLine .h-elformWrap-2,
    .n-chan .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .pieceCon, .product {
        width: 92%;
        border-radius: 4px;
    }

    h1 {
        margin-left: 15px;
    }

    .N-chan .h-pieceTitle2 {
        margin-bottom: 0.4rem;
        margin-left: 0;
    }

    .bigDiv {
        margin: 20px;
    }
</style>
<style>

    .el-radio__label {
        font-size: 0.23rem;
    }

    .block .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 168px;
    }

    .n-bu .h-formbLine .el-form-item__label {
        width: 47%;
        vertical-align: top;
    }

    .n-bu .h-formbLine .el-form-item__content {
        width: 53%;
    }

    .n-bu .h-formbLine .h-elformWrap-3 {
        width: 100%;
    }

    .n-bu .h-formbLine .h-elformWrap-3 .el-form-item__label {
        width: 10.7%;
    }

    .n-bu .h-formbLine .h-elformWrap-3 .el-form-item__content {
        width: 73.3%;
    }

    .yxtable .el-date-editor .el-range-separator {
        line-height: 0.26rem;
        font-size: 0.16rem;
    }

    .ljjtable .el-table .el-input--suffix .el-input__inner {
        font-size: 0.16rem;
    }

    .ljjtable .el-table .el-input__inner {
        font-size: 0.16rem;
    }
    .ahstyles .el-input.is-disabled .el-input__inner{
        background: transparent;
        color: #616467;
    }
    .ljjtablepaddings1 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings1 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .ljjtablepaddings1 .el-table tbody td .cell{
        padding: 0.05rem 0.1rem;
    }
</style>


<style scoped lang="scss">
    $ft-colorg: #21d16f; //绿色的字
    $ft-coloro: #e79118; //黄色的字
    $bg-colorg: #f6fffa; //绿色的背景色
    $bg-coloro: #fffbf7; //黄色的背景色
    $bg-colorb: #3b77fc; //蓝色
    $bg-colorgrey: #c3c3c3; //灰色
    .yx_progressBar {
        width: 100%;
        border: 1px solid $ft-colorg;
        background-color: $bg-colorg;
        padding: 0.38rem;
        position: relative;

        .yxExtra {
            position: absolute;
            color: $ft-colorg;
            top: 0.3rem;
            font-size: 0.18rem;
            right: 0.3rem;
        }

        .yx_topTip {
            display: flex;
            justify-content: flex-start;
            color: #424441;
            font-size: 0.18rem;

            .leftdes {
                margin-right: 0.75rem;
            }

            .percent {
                color: $ft-colorg;
            }
        }

        .con_progress {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 0.3rem;

            .eve_proout {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                &:last-child .line_pro {
                    display: none;
                }

                .eve_pro {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    position: relative;
                    background-color: $bg-colorgrey;

                    .persons {
                        position: absolute;
                        top: 20px;
                        min-width: 1.8rem;
                        text-align: center;
                        margin-left: -0.75rem;
                        margin-top: 0.04rem;
                        font-size: 0.18rem;
                    }

                    .personsAc {
                        color: $bg-colorb;
                    }
                }


                .line_pro {
                    width: 3rem;
                    height: 4px;
                    background-color: $bg-colorgrey;
                }

                // 激活
                .eve_proAc {
                    background-color: $bg-colorb;
                }

                .line_proAc {
                    width: 3rem;
                    height: 4px;
                    background-color: $bg-colorb;
                }

                .eve_proAcpass {
                    background-color: $bg-colorgrey;
                }

                .line_proAcpass {
                    width: 3rem;
                    height: 4px;
                    background-color: $bg-colorb;
                }
            }

        }
    }

    .yx_progressBarAc {
        border: 1px solid $ft-coloro;
        background-color: $bg-coloro;

        .yxExtra {
            color: $ft-coloro;
        }

        .yx_topTip {
            .percent {
                color: $ft-coloro;
            }
        }
    }


    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .product {
        margin-top: 10px;

    }

    .Ptitle {
        margin-top: 30px;
    }

    .resultA {
        border: 1px solid rgb(104, 184, 108);
        background-color: rgb(224, 233, 224);
        color: rgb(126, 216, 130);
    }

    .resultA, .resultB {
        width: 100%;
        height: 150px;
        border-radius: 4px;
        margin: 20px 0;
    }

    .resultB {
        border: 1px solid rgba(233, 161, 52, 0.925);
    }

    h6 > span {
        color: greenyellow;
    }

    h6 > .span {
        color: rgba(233, 161, 52, 0.925);
    }

    .xia {
        display: flex;
        justify-content: center;
        margin-top: 0.7rem
    }

</style>
